export const en = {
	translation: {
		"--": "--",
		gallery: {
			gallery: "Gallery",
		},
		resource_links: {
			resource_links: "Resource Links",
			add_resource_link: "Add Resource Link",
			edit_resource_link: "Edit Resource Link",
			no_resource_links: "No resource links available",
			link: "Link",
			name: "Name",
			links: "Links",
			types: {
				trimble: "Trimble",
			},
			not_found: "This link no longer exists.",
		},
		image_annotator: {
			image_editor: "Image Editor",
			pick_annotation: "Pick annotation",
			annotations: "Annotations",
			no_annotations_yet: "No annotations yet",
			edit_annotations: "Edit annotaions",
			show_annotations: "Show annotations",
			download_image: "Download",
			share_image: "Share",
			export_failed: "The image could not be exported",
			share_unavailable: "Sharing images is not supported in this browser",
			patterns: {
				solid: "Solid",
				hatch: "Hatch",
				crosshatch: "Crosshatch",
				dots: "Dots",
				checker: "Checker",
				waves: "Waves",
				stripes: "Stripes",
				grid: "Grid",
				plus: "Plus",
				none: "None",
			},
			tools: {
				tools: "Tools",
				dimension: "Dimension",
				polygon: "Polygon",
				select: "Select",
				text: "Text",
			},
			fill_color: "Fill Color",
			stroke: "Stroke",
			fill: "Fill",
			font_size: "Font Size",
			offset: "Offset",
			tilt: "Tilt",
			continue_dimension: "Continue Measurement",
			text_placeholder: "Text",
			stroke_color: "Stroke Color",
			stroke_width: "Stroke Width",
			marker_color: "Marker Color",
			text: "Text",
			pattern: "Pattern",
			opacity: "Opacity",
		},
		controlling: {
			controlling: "Controlling",
			average_invoice_sum: "Average Invoice Sum",
			incoming_invoices: "Incoming Invoices",
			invoice: "Invoice",
			invoice_reminders: "Reminders",
			delivery_notes: "Delivery notes",
			payment_files: "Payment files",
			invoices: "Invoices",
			my_invoice_approvals: "My Invoice Approvals",
			offers: "Offers",
			outgoing_invoices: "Outgoing Invoices",
			total_invoice_sum: "Total Invoice Sum",
		},
		address: {
			address: "Address",
			city: "City",
			country: "Country",
			house_number: "House number",
			street: "Street",
			zip_code: "ZIP",
			coordinates_not_found:
				"This address could not be located. Check the street, postcode and city.",
		},
		auth: {
			enter_your_pin: "Enter your PIN",
			invalid_badge_id: "Invalid badge ID",
			invalid_pin: "Invalid PIN",
			loading_session: "Loading session...",
			confirm_password: "Confirm Password",
			forgot_password: "Forgot password?",
			new_password: "New Password",
			api_key: "API Key",
			username: "Username",
			password: "Password",
			remember_me: "Remember me",
			reset_password: "Reset password",
			get_password_reset_link: "Get password reset link",
			password_reset_link_sent: "Password reset link sent",
			signin: "Sign in",
			signout: "Sign out",
			signup: "Sign up",
			signin_with_qr: "Sign in with QR code",
			unauthorized: "Unauthorized",
			updated_password: "Updated Password",
			account: "Account",
		},
		chats: {
			chat: "Chat",
			chats: "Chats",
			message: "Message",
			messages: "Messages",
			send_message: "Send message",
			write_a_message: "Write a message",
		},
		cms: {
			cms: "CMS",
		},
		confirmation: {
			confirm_discard: "Are you sure you want to discard your changes?",
			confirm_deactivation:
				"Are you sure you want to deactivate this item? This action can be undone.",
			confirm_deletion: "Are you sure you want to delete this item? This action cannot be undone.",
		},
		images: {
			images: "Images",
			image: "Image",
			not_found: "This image is no longer available.",
			take_photo: "Take Photo",
		},
		contacts: {
			vat_id: "VAT ID",
			tax_number: "Tax number",
			bank_accounts: {
				bank_accounts: "Bank accounts",
				add: "Add bank account",
				edit: "Edit bank account",
				bank_name: "Bank",
				is_default: "Default",
				source: "Source",
				sources: {
					invoice: "From an invoice",
					manual: "Entered",
				},
				delete_confirm_message: "Do you really want to remove this bank account?",
				duplicate_iban: "The contact already has this IBAN.",
			},
			related_contact: "Related Contact",
			add_contact: "Add Contact",
			add_member: "Add Member",
			contact: "Contact",
			contacts: "Contacts",
			edit_contact: "Edit Contact",
			edit_contact_project_override: "Edit for project",
			edit_member: "Edit Member",
			edit_member_project_override: "Edit for project",
			fields: {
				name: "Name",
			},
			members: "Members",
			member_types: "Member Types",
			member_authorizations: "Member Authorizations",
			delete_contact_member: "Delete Contact Member",
			delete_contact_member_confirm_message:
				"Are you sure you want to delete this contact member? This action cannot be undone.",
			superior_contact: "Superior Contact",
			contact_types: "Contact Types",
			select_contact: "Select Contact",
			not_found: "This contact no longer exists.",
			member_not_found: "One of the selected contact persons no longer belongs to this contact.",
		},
		dates: {
			weekdays: "Weekdays",
			all_day: "All Day",
			calendar: "Calendar",
			calendarweek: "Calendarweek",
			calendarweek_abbr: "CW",
			current_month: "Current month",
			today: "Today",
			date: "Date",
			dates: "Dates",
			time_suffix: "h",
			hours_abbr: "h",
			minutes_abbr: "min",
			on_the_same_day_at: "On the same day at",
			on_the_previous_workday_at: "On the previous workday at",
			time: "Time",
			start_time: "Start Time",
			end_time: "End Time",
			friday: "Friday",
			monday: "Monday",
			saturday: "Saturday",
			select_date: "Select date",
			select_time: "Select time",
			select_value: "Select value",
			sunday: "Sunday",
			thursday: "Thursday",
			tuesday: "Tuesday",
			wednesday: "Wednesday",
			start_date: "Start date",
			end_date: "End date",
			day: "Day",
			days: "Days",
			week: "Week",
			weeks: "Weeks",
			month: "Month",
			months: "Months",
			quarter: "Quarter",
			quarters: "Quarters",
			year: "Year",
			years: "Years",
			end_date_cant_be_before_start_date: "Enddate can't be before startdate",
		},
		personio: {
			open_personio_to_update: "Open Personio to update",
			absence_categories: {
				paid_vacation: "Vacation (Paid)",
				unpaid_vacation: "Vacation (Unpaid)",
				sick_leave: "Sick Leave",
				parental_leave: "Parental Leave",
				special_leave: "Special Leave",
				offsite_work: "Offsite Work",
				azk_freizeitausgleich: "Compensatory Absence",
				other: "Other",
			},
			status: {
				requested: "Requested",
				approved: "Approved",
				denied: "Denied",
				canceled: "Canceled",
				scheduled: "Scheduled",
				taken: "Taken",
				pending: "Pending",
				rejected: "Rejected",
			},
		},
		disclosure: {
			collapse: "Collapse",
			expand: "Expand",
		},
		documents: {
			acknowledgement_interval: "Acknowledgement interval",
			acknowledgement_interval_months_1: "Monthly",
			acknowledgement_interval_months_3: "Every 3 months",
			acknowledgement_interval_months_6: "Every 6 months",
			acknowledgement_interval_months_12: "Yearly",
			acknowledgement_interval_months_24: "Every 2 years",
			add_documents: "Add Documents",
			document: "Document",
			documents: "Documents",
			edit_document: "Edit Document",
		},
		file_upload: {
			delete_file_confirm_message:
				"Are you sure you want to delete this file? This action cannot be undone. This also affects all references to this file on other instances.",
			drop_files_here: "Drop files here",
			drop_files_to_sort: "Drop files here and auto-sort",
			file_upload: "File Upload",
			files_uploaded_successfully: "Files uploaded successfully",
			n_files_could_not_be_sorted: "{count} files could not be sorted",
			n_files_sorted: "{count} files sorted",
			n_files_uploading: "Uploading {count} files...",
			new_files: "New files",
			open_inbox: "Open inbox",
			show_details: "Show details",
			previous_files: "Previous files",
			release_to_drop: "Release to drop them here",
			select_files_or_drop_here: "Select files or drop them here",
			sorting_n_files: "Sorting {count} files...",
			unlink_file_confirm_message:
				"Are you sure you want to unlink this file? It will only be removed from this list; the file itself stays available anywhere else it is linked.",
			upload: "Upload",
			upload_failed: "Upload failed",
			upload_files: "Upload files",
			upload_image: "Upload image",
			upload_logo: "Upload logo",
			uploaded: "Uploaded",
			uploading: "Uploading...",
		},
		files: {
			inbox: "File inbox",
			inbox_collections: {
				outgoingInvoiceFiles: "Invoice",
				projectDocumentFiles: "Project documents",
				protocolFiles: "Protocol",
				serviceCalculationFiles: "Calculation",
				ticketFiles: "Ticket",
			},
			batch_overview: "File assignment",
			batch_overview_empty: "This drop is no longer on record.",
			outcome: "Outcome",
			outcome_linked: "Filed",
			outcome_pending: "Being sorted",
			outcome_unplaced: "Not filed",
			outcome_unknown_record: "The record is no longer available",
			inbox_dropped_at: "Dropped at",
			inbox_dropped_by: "Dropped by",
			inbox_failed: "Failed",
			inbox_file_it: "File {file}",
			inbox_file_it_action: "File it",
			inbox_file_it_into: "File it into",
			inbox_no_active_tickets: "This project has no active tickets.",
			inbox_no_protocols: "This project has no protocols.",
			inbox_pick_destination: "Pick destination",
			inbox_pick_project_first: "Pick a project to choose a record.",
			inbox_records_failed: "The list could not be loaded.",
			inbox_reason: "Why it is here",
			inbox_record: "Record",
			inbox_suggestions: "Suggestions",
			import_file: "Import File",
			file: "File",
			files: "Files",
			no_files_available: "No files available",
			open_file: "Open File",
			include_all: "Include all",
			include_container_only: "Include container only",
			drop_files_here: "Drop files here",
			file_name: "File Name",
			file_size: "File Size",
			dimensions: "Dimensions",
			full_path: "Full Path",
			folder_name: "Folder Name",
			folder: "Folder",
			folders: "Folders",
			folder_size: "Folder Size",
			signed_url: "Signed URL",
			n_files_selected: "Files selected: {count}",
			focused_item: "Focused Item: {name}",
			total_files: "Total Files: {count}",
			cannot_move_files: "You may not move these files.",
			batch_delete_refused: "Nothing was deleted. You may not change these files: {files}",
			batch_move_refused: "Nothing was moved. You may not change these files: {files}",
			batch_move_failed:
				"The folder already holds a file of the same name, so these stayed where they were: {files}",
			delete_file: "Delete File",
			delete_n_files: "Delete {count} Files",
			download_n_files: "Download {count} Files",
			download: "Download",
			download_all: "Download All",
			delete_file_confirm_message:
				"Are you sure you want to delete this file? This action cannot be undone.",
			delete_files_confirm_message:
				"Are you sure you want to delete these files? This action cannot be undone.",
			move_all_selected_files_to_folder_confirm_message:
				"Are you sure you want to move all selected files to this folder? Press 'No' to just move the actually dragged file.",
			move: "Move files",
			dont_move: "Don't move files",
			create_folder: "Create Folder",
			moving_files: "Moving files...",
			moved_files_successfully: "Files moved successfully",
			error_moving_files: "Error moving files",
			processing_file: "Processing file...",
			failed_processing_file: "Failed processing file...",
			successfully_processed_file: "Successfully processed file.",
		},
		general: {
			converting: "Converting...",
			error: "Error",
			show_all: "Show all",
			total: "Total",
			approved_by: "Approved by",
			approved_at: "Approved at",
			rejected_by: "Rejected by",
			rejected_at: "Rejected at",
			update: "Update",
			order_by: "Order by",
			reject: "Reject",
			approve: "Approve",
			all: "All",
			start: "Start",
			end: "End",
			standard: "Standard",
			label: "Label",
			retry: "Retry",
			canceled: "Canceled",
			number: "Number",
			select_columns: "Select Columns",
			identifier: "Identifier",
			quantity: "Quantity",
			scope: "Scope",
			scope_user: "Just me",
			scope_global: "Global",
			deleting: "Deleting...",
			updating: "Updating...",
			successfully_deleted: "Successfully deleted",
			successfully_updated: "Successfully updated",
			deleting_failed: "Deleting failed",
			updating_failed: "Updating failed",
			is_required: "Is required",
			not_required: "Not required",
			source: "Source",
			progress: "Progress",
			join: "Join",
			global: "Global",
			references: "References",
			menu: "Menu",
			link: "Link",
			duplicate: "Duplicate",
			summary: "Summary",
			fill_in_required_fields: "Please fill in all required fields",
			description: "Description",
			copy_link: "Copy Link",
			copied_link: "Copied link to clipboard",
			copied_to_clipboard: "Copied to clipboard",
			invalid_iban: "Invalid IBAN",
			no_access: "You do not have access to this resource.",
			checking_permissions: "Checking your permissions...",
			permissions_unavailable: "Your permissions could not be checked. Please try again.",
			forbidden: "You do not have permission to perform this action.",
			internal_error: "An internal error occurred. Please try again later.",
			request_failed: "The request could not be completed.",
			content_not_loadable: "This content could not be loaded.",
			active: "Active",
			text: "Text",
			add: "Add",
			advanced: "Advanced",
			back: "Back",
			cancel: "Cancel",
			caution: "Caution",
			close: "Close",
			confirm: "Confirm",
			continue: "Continue",
			other: "Other",
			create: "Create",
			delete: "Delete",
			deleted_successfully: "Deleted successfully",
			details: "Details",
			dismiss: "Dismiss",
			dismiss_unsaved_changes:
				"Are you sure you want to dismiss unsaved changes? This action cannot be undone.",
			done: "Done",
			edit: "Edit",
			rename: "Rename",
			enter_value: "Enter value",
			export: "Export",
			export_as_csv: "Export as CSV",
			extended: "Extended",
			filter: "Filter",
			general: "General",
			name: "Name",
			history: "History",
			home: "Home",
			inactive: "Inactive",
			information: "Information",
			loading: "Loading",
			no: "No",
			no_data_available: "No data available",
			not_found: "Not found",
			notes: "Notes",
			open: "Open",
			optional: "Optional",
			overview: "Overview",
			pending: "Pending",
			approved: "Approved",
			refresh: "Refresh",
			remove: "Remove",
			reset: "Reset",
			save: "Save",
			saved: "Saved",
			search: "Search",
			select: "Select",
			select_all: "Select All",
			deselect_all: "Deselect All",
			select_existing_files: "Select Existing Files",
			selected: "Selected",
			send: "Send",
			settings: "Settings",
			something_went_wrong: "Something went wrong",
			state: "State",
			submit: "Submit",
			value: "Value",
			yes: "Yes",
			unauthorized: "Unauthorized",
			too_many_requests: "Too many requests. Please wait a moment and try again.",
			unknown: "Unknown",
			order_direction: "Order Direction",
			order_direction_asc: "Ascending",
			order_direction_desc: "Descending",
			preview: "Preview",
			pdf_preview: "PDF Preview",
			download: "Download",
			i_do_understand_the_consequences: "I do understand the consequences",
			danger_zone: "Danger Zone",
			i_understand: "I understand",
			type: "Type",
			last_updated: "Last updated",
			options: "Options",
			just_save: "Just save",
			no_menu_items_available: "No menu items available",
		},
		general_fields: {
			created_at: "Created at",
			created_by: "Created by",
			deleted_at: "Deleted at",
			deleted_by: "Deleted by",
			id: "ID",
			state: "State",
			updated_at: "Updated at",
			updated_by: "Updated by",
		},
		greetings: {
			hello: "Hello",
			good_morning: "Good morning",
			good_afternoon: "Good afternoon",
			good_evening: "Good evening",
			good_night: "Good night",
		},
		hints: {
			hint: "Hint",
			please_fill_out_all_fields: "Please fill out all fields",
			you_can_change_this_at_any_time: "You can change this at any time",
		},
		home: {
			groups: {
				general: "General",
				commercial: "Commercial",
				team: "Team",
				personal: "My Space",
				favorites: "Favorites",
			},
			/**
			 * The one action a tile's long-press menu offers, worded for the state the tile is in.
			 */
			add_to_favorites: "Add to favorites",
			remove_from_favorites: "Remove from favorites",
			/**
			 * One line per destination a home-menu tile leads to, keyed by that screen rather than by
			 * the menu it appears in — a tile pinned to the favorites shows there and in its group,
			 * and a screen only ever has one description.
			 */
			descriptions: {
				incoming_invoice_approvals: "Supplier invoices waiting on your review",
				returns: "Material coming back off a site",
				planning: "Crews and tickets, day by day",
				projects: "Sites, their teams and tickets",
				protocols: "Meetings, calls and site notes",
				vehicles: "The fleet, vehicle by vehicle",
				wiki: "Spaces and pages the team writes",
				invoices: "What is billed, and what is open",
				controlling: "Measurements and their invoices",
				calculations: "What a job is priced at",
				services: "The catalogue of what you offer",
				contacts: "Companies and the people there",
				partners: "Partner firms and their bookings",
				bookings: "Submit and review timesheets",
				submit_bookings: "Hours of your crews on partners' sites",
				review_bookings: "Partners' hours on your sites",
				users: "Everyone who works here",
				absence_calendar: "Who is away, and when",
				attendance_approvals: "Your team's times to approve",
				absence_approvals: "Your team's leave to approve",
				attendances: "Your own times, day by day",
				my_absences: "Your leave, year by year",
				substitutions: "Who covers while you are away",
				measurements: "Measured work per project manager",
				controlling_invoices: "Every invoice, filtered by state",
				articles: "Everything on the shelves",
				warehouse_zones: "Where stock is stored",
				load_carriers: "Pallets, boxes and baskets",
				transport_orders: "Carriers waiting to be moved",
				put_away: "Returned material waiting for a shelf",
				orders: "What goes out and comes back",
				my_orders: "Deliveries to the sites you run",
				article_groups: "How articles are grouped",
				article_product_types: "What kind of article it is",
				tour_waves: "Delivery tours and their cutoffs",
				order_templates: "Orders worth reusing",
				picking: "Suborders waiting to be picked",
				settings: "Profile, language and signing out",
			},
		},
		incoming_invoices: {
			add_cost_allocation_row: "Add cost center",
			allocated: "Allocated",
			allocated_by: "Split by",
			allocation_source: {
				manual: "Set by hand",
				suggested: "Suggested by AI",
			},
			amount: "Amount",
			amounts: "Amounts",
			approval_comment: "Comment",
			approval_comment_placeholder: "Reason",
			decision: {
				review: "Review",
				title: "Review invoice",
				accept: "Accept",
				reject: "Reject",
				cost_allocation: "Cost allocation",
				reduce: "Reduce amount",
				reduce_hint: "Pay less than the invoice asks for. The cost allocation scales with it.",
				printed_net_amount: "Invoiced net amount",
				reduced_net_amount: "Reduced net amount",
				reduction_reason: "Reason for the reduction",
				reduction_reason_required: "A reduction needs a reason",
				reduced_amount_required: "Enter a reduced net amount above zero",
				reduction_too_high: "The reduced amount must be below the invoiced net amount",
				comment: "Note (optional)",
				comment_placeholder: "e.g. checked against the delivery note",
				rejection_reason: "Reason for the rejection",
				submit_accept: "Accept invoice",
				submit_reject: "Reject invoice",
				skip_chain_title: "Decide ahead of the chain?",
				skip_chain_message:
					"{count} approver(s) before you have not decided yet. Deciding now skips them. Continue?",
				your_turn: "Your turn",
				waiting_for: "Waiting for {name}",
				waiting: "Waiting",
				chain_position: "Order",
				reduced_from: "Reduced from {from} to {to}",
				reduced_by: "Reduced by",
				reductions: "Reductions",
				allocation_must_match: "The cost allocation must add up to {amount}",
				no_cost_centers: "The organisation keeps no cost centres to allocate to.",
				add_cost_center: "Add cost centre",
				history: "Decisions",
				not_your_turn: "It is not your turn in the approval chain yet.",
				cannot_take_back: "Someone after you in the chain has already decided.",
				handover_not_entitled:
					"Only a default approver or the approver handed the invoice last can hand it on.",
				handover_sole_approver:
					"The invoice has a sole approver. Withdraw that handover before handing it over again.",
				share: "Share",
				amount: "Amount",
				allocation_sum_mismatch: "The cost allocation must add up to the net amount",
				unknown_cost_center: "A cost centre of the allocation is not active",
			},
			approval_state: {
				approved: "Approved",
				pending: "Pending",
				rejected: "Rejected",
				skipped: "Skipped",
				state: "State",
			},
			approvals_filter: {
				decided: "Decided",
				pending: "Open",
			},
			approve: "Approve",
			approver: "Approver",
			approver_set: "Applies to",
			approvers_need_read_rule:
				"Only members whose role lets them view incoming invoices can approve.",
			approvers_required: "The organisation needs at least one default approver",
			awaiting_approval: "Awaiting Approval",
			bic: "BIC",
			by_state: "By State",
			calendar_week: "CW {week}",
			check_groups: {
				arithmetic: "Arithmetic Review",
				formal: "Formal Review",
			},
			check_hints: {
				difference: "Off by {amount}",
				duplicate_of: "Duplicate of {number}",
				incomplete: "Too little to compare",
				invalid_iban: "IBAN misread",
				no_cost_centers: "No cost centers",
				no_positions: "No positions",
				same_document_as: "Same document as {number}",
				new_iban: "New IBAN",
				suspected_fraud: "Suspected fraud",
				unknown_partner_iban: "Unknown to the partner",
			},
			checks: {
				cost_allocation_complete: "Cost allocation complete",
				gross_matches_net_plus_vat: "Gross = net + VAT",
				iban_known: "IBAN known for the supplier",
				invoice_date_present: "Invoice date present",
				issuer_assigned: "Supplier assigned",
				no_duplicate: "Not a duplicate",
				number_present: "Invoice number present",
				positions_match_net: "Positions add up to the net total",
				tax_id_known: "Tax number or VAT ID known",
			},
			contact: "Contact",
			cost_allocation: "Cost Allocation",
			cost_allocation_must_add_up: "The amounts have to add up to the net amount exactly",
			cost_allocation_remaining: "Left to allocate: {amount}",
			currency: "Currency",
			decided_at: "Decided at",
			default_approvers: "Default Approvers",
			details: "Details",
			dismiss_duplicate: "Not a duplicate",
			document: "Document",
			due_date: "Due Date",
			due_in_7_days: "Due in 7 Days",
			due_per_week: "Due per Week",
			duplicate_description:
				"It repeats an earlier invoice and is counted nowhere until it is merged into it or declared none.",
			duplicate_title: "Duplicate of {number}",
			edit_cost_allocation: "Edit cost allocation",
			edit_default_approvers: "Default approvers: {name}",
			edit_invoice: "Edit invoice",
			email_arrived_at: "Email arrived",
			events: {
				approval_requested: "asked for approval",
				approval_withdrawn: "took back a handover",
				approved: "approved the invoice",
				checked: "checked the invoice",
				cost_allocation_changed: "changed the cost allocation",
				cost_allocation_cleared: "cleared the cost allocation",
				cost_allocation_suggested: "suggested a cost allocation",
				decision_taken_back: "took a decision back",
				duplicate_detected: "recognised a duplicate",
				duplicate_dismissed: "declared it no duplicate",
				duplicate_merged: "merged a duplicate into this invoice",
				field_changed: "changed fields",
				merged_into: "merged this invoice into its original",
				open_other_invoice: "Open the other invoice",
				read: "read the invoice",
				read_failed: "could not read the invoice",
				received: "received the invoice by email",
				rejected: "rejected the invoice",
				reminder_received: "received a reminder",
				payment_exported: "exported the payment",
				payment_reverted: "took the payment back",
				iban_confirmed: "confirmed the IBAN for the supplier",
				approval_skipped: "skipped an approval",
				amount_reduced: "reduced the amount",
				reduction_lifted: "lifted the reduction",
				delivery_note_linked: "linked a delivery note",
				delivery_note_unlinked: "removed a delivery note",
				approvals_reset: "reset the review",
				state_changed: "changed the state",
				system: "System",
			},
			extraction_error: "Why it could not be read",
			extraction_failed: "Could not be read",
			failed_checks_description:
				"{count} review check(s) of this invoice failed. You can approve it anyway.",
			failed_checks_title: "Not every check passed",
			failed_checks_count: "{count} check(s) failed",
			approvers_title: "Reviewers",
			falls_back_to_organization_approvers: "The organisation's approvers",
			falls_back_to_owner: "The organisation owner",
			gross_amount: "Gross",
			gross_hint: "gross",
			handover: {
				asked_by: "Asked by",
				default_approver: "Default approver",
				hand_over: "Hand over approval",
				handed_over: "Handed over",
				not_required: "No longer required",
				sole: "Sole approval",
				sole_description:
					"Only this person's approval counts; every other approval of the invoice is removed. Taking the handover back asks the default approvers again.",
				sole_label: "Sole approval",
				withdraw: "Take back handover",
			},
			iban: "IBAN",
			incoming_invoice: "Incoming invoice",
			invoice: "Invoice",
			invoice_date: "Invoice Date",
			invoice_n: "Invoice {number}",
			issuer: "Issued by",
			issuer_address: "Address",
			issuer_email: "Email",
			issuer_name: "Company",
			issuer_phone: "Phone",
			kind: {
				credit_note: "Credit note",
				final_invoice: "Final invoice",
				invoice: "Invoice",
				partial_invoice: "Partial invoice",
			},
			kind_label: "Kind",
			mailboxes: "Mailboxes",
			merge_duplicate: "Merge into original",
			merge_duplicate_confirm_message:
				"Merge this duplicate into the original? Its document and notes move there, and it disappears from every list.",
			n_invoices: "{count} invoices",
			net_amount: "Net",
			net_hint: "net",
			no_document: "No document filed under this invoice",
			not_allocated: "Not allocated",
			not_allocated_yet: "Not split yet",
			not_found: "This invoice no longer exists.",
			number: "Invoice Number",
			open: "Open",
			open_invoice: "Open invoice",
			organization_approvers: "Organisation (all other invoices)",
			overdue: "Overdue",
			partner: "Partner",
			partner_report_summary: "Report for CW {week}, {total}",
			payment: "Payment",
			position_description: "Description",
			position_number: "Pos.",
			position_total: "Total",
			positions: "Positions",
			quantity: "Quantity",
			received_per_month: "Received per Month",
			received_at: "Received",
			received_at_hint:
				"When the email arrived, moved into the workspace's business hours: an email that arrives while the office is closed counts as received when it next opens.",
			recipient: "Addressed to",
			reject: "Reject",
			rejection_comment_required: "Say why the invoice is rejected",
			e_invoice_format: {
				zugferd: "E-invoice (ZUGFeRD)",
				xrechnung: "E-invoice (XRechnung)",
			},
			delete_invoice: "Delete invoice",
			delete_invoice_description:
				"Permanently delete this invoice with its positions, approvals, checks, cost allocation, notes and timeline. The attached document stays with its email. This cannot be undone.",
			delete_invoice_confirm_message:
				"Are you sure you want to delete this invoice? This cannot be undone.",
			delete_invoice_type_to_confirm: 'Type "{phrase}" to confirm',
			delete_paid_refused: "A paid invoice cannot be deleted. Take its payment back first.",
			reset: {
				title: "Reset review",
				description:
					"Remove every approval, ask the default approvers again and lift the reduction. The cost allocation and the decision history stay. An approved invoice can only be changed after a reset.",
				button: "Reset review",
				confirm_message: "Reset this invoice's review? Every approval taken so far is discarded.",
				locked: "An approved invoice can no longer be changed. Reset its review first.",
				paid_refused: "A paid invoice cannot be reset. Take its payment back first.",
				duplicate_refused: "A duplicate is merged or declared none rather than reset.",
				done: "Review reset",
			},
			iban_check: {
				new_title: "New IBAN: {iban}",
				new_description:
					"The supplier has no bank account on file yet. Confirm this IBAN with the supplier over a channel you already know — not the contact details on the invoice — before approving.",
				fraud_title: "Suspected fraud: unknown IBAN {iban}",
				fraud_description:
					"The supplier is on file with other bank accounts. Forged invoices ask for payment to a new account — confirm it with the supplier over a channel you already know before approving, and reject the invoice if in doubt.",
				confirm: "Confirm IBAN",
				confirm_message:
					"Add this IBAN to the supplier's bank accounts? Only do so once the supplier has confirmed it. Your confirmation is recorded.",
				approval_blocked: "Confirm the invoice's IBAN before approving it.",
				not_an_approver: "Only an approver of this invoice can confirm its IBAN.",
				partner_title: "IBAN unknown to the partner: {iban}",
				partner_description:
					"None of the partner organisation's workspaces carries this IBAN. Ask the partner to add it to their workspace's bank details, then check again — until then the invoice cannot be approved.",
				recheck: "Check again",
				no_valid_iban: "The invoice prints no valid IBAN to confirm.",
				no_contact: "Book the invoice to a contact before confirming its IBAN.",
				partner_still_unknown: "The partner's workspaces still do not carry this IBAN.",
			},
			payments: {
				exported_at: "Exported",
				exported_by: "Exported by",
				invoices: "Invoices paid",
				export_payments: "Export payments",
				export_payments_count: "Export payments ({count})",
				export_payment_file: "Export payment file",
				export_hint:
					"The file is written for StarMoney or any banking software that imports SEPA files. The invoices are marked as paid once it is downloaded.",
				apply_skonto: "Deduct open Skonto",
				apply_skonto_description:
					"Takes the Skonto off every invoice whose Skonto deadline has not passed yet.",
				format: "Format",
				format_09: "pain.001.001.09 — current standard",
				format_03: "pain.001.001.03 — older banking software",
				execution_date: "Execution date",
				transfer_count: "Transfers",
				invoice_count: "Invoices",
				total: "Total",
				skonto_total: "Skonto",
				exported: "Payment file exported, {count} invoice(s) marked as paid",
				not_payable: "Some of these invoices cannot be paid.",
				not_payable_title: "Cannot be paid",
				not_paid: "The invoice is not paid.",
				revert_payment: "Take back payment",
				revert_payment_message:
					"The invoice is set back to approved and can be paid in a later file. Make sure the bank has not executed the transfer.",
				payment_reverted: "Payment taken back",
				download_file: "Download payment file",
				payable: "Payable",
				paid_amount: "Paid",
				skonto_taken: "Skonto taken",
				offsets: {
					offset: "Offset",
					offsets: "Offset",
					title: "Offset {number}",
					hint: "Open outgoing invoices of the projects whose client is {supplier}. When the payment file is exported, they are taken off the payment in the order you pick them, each up to what it still owes. Amounts are net: outgoing invoices between construction firms are reverse charge.",
					planned_hint: "Taken off the transfer in this order when the payment file is exported.",
					none_planned: "{count} open outgoing invoice(s) to this supplier — no offset planned",
					saved: "Offset saved",
					sum: "Sum (net)",
					open_amount: "Open (net)",
					applied: "Taken off",
					not_reached: "Not reached",
					not_reached_hint:
						"The payment is covered before this invoice is reached, so it would offset nothing. Remove it.",
					used_elsewhere: "Already planned against {number}",
					no_candidates: "No open outgoing invoices to this supplier",
					load_failed: "The open outgoing invoices could not be loaded.",
					apply: "Apply",
					payment: "Payment",
					total: "Offset",
					to_transfer: "To transfer",
					transferred: "Transferred",
					paid_by_offset: "No transfer — paid by offset",
					less_offset: "Less offset",
					less_offsets: "Less offset {numbers}",
					settled_without_file:
						"No payment file needed: {count} invoice(s) settled by offset and marked as paid",
					offset_only: "Settled by offset",
					no_file: "No payment file — every invoice in this run was settled by offset",
					closed: "The offset of a paid or closed invoice can no longer be changed.",
					not_available:
						"A picked outgoing invoice is no longer open or is not billed to this supplier.",
					planned_elsewhere:
						"Outgoing invoice {number} is already planned against another invoice.",
				},
				reasons: {
					"not-approved": "Not approved",
					"credit-note": "Credit note",
					"not-eur": "Not in euros",
					"no-amount": "No gross amount",
					"no-creditor": "No supplier",
					"invalid-offset": "An offset does not fit this invoice",
					"unconfirmed-iban": "IBAN not confirmed by an approver",
					"no-creditor-iban": "No valid supplier IBAN",
					"no-paying-account": "Workspace has no bank account",
				},
			},
			reminders: {
				link_invoice: "Link invoice",
				link_invoice_hint:
					"The reminder names invoice {number}. Pick the invoice it reminds of, or empty the field to take a wrong link back.",
				search_invoice: "Search an invoice number or supplier",
				amount_due: "Amount Due",
				due_fee: "Pay by {dueDate}, fee {fee}",
				fee: "Fee",
				level: "Level",
				level_1: "1st Reminder",
				level_2: "2nd Reminder",
				level_3: "Final Reminder",
				reminder: "Reminder",
				reminder_date: "Date",
				reminders: "Reminders",
				summary: "from {date}, pay by {dueDate}, fee {fee}",
				unmatched: "Not matched",
			},
			delivery_notes: {
				delivery_note: "Delivery note",
				delivery_notes: "Delivery notes",
				number: "Delivery note no.",
				delivery_date: "Delivery date",
				order_reference: "Order",
				title: "Delivery note {number}",
				position_count: "{count} lines",
				link_invoice: "Link invoice",
				link_invoice_hint:
					"Delivery note {number}. Pick the invoice that bills it, or empty the field to take a wrong link back.",
				link_delivery_note: "Link delivery note",
				link_delivery_note_hint: "Delivery notes no invoice holds yet.",
				select_delivery_note: "Select a delivery note",
				unlink: "Unlink",
				waiting: "Waiting for invoice",
				not_received: "Not received yet",
				none: "No delivery note linked",
			},
			report_not_found: "No partner report carries this number",
			report_number: "Report Number",
			requested_at: "Requested at",
			review: "Review",
			review_requested: {
				title: "Invoice to review",
				received: "{invoice} awaits your review.",
				handed_over: "{name} handed you {invoice} to review.",
				turn: "{invoice} is now with you to review.",
				returned: "{name} approved {invoice} – it is back with you to review.",
				from_issuer: "from {issuer}",
				for_amount: "for {amount}",
			},
			review_decided: {
				approved_title: "Invoice approved",
				rejected_title: "Invoice rejected",
				approved: "{name} approved {invoice}.",
				approved_with_comment: "{name} approved {invoice}: {comment}",
				rejected: "{name} rejected {invoice}.",
				rejected_with_comment: "{name} rejected {invoice}: {comment}",
				someone: "A reviewer",
			},
			share: "Share",
			skonto_amount: "Cash Discount Amount",
			skonto_deadline: "Cash Discount Until",
			skonto_rate: "Cash Discount",
			skonto_summary: "{rate} until {date}",
			source: "Source",
			state: {
				approved: "Approved",
				duplicate: "Duplicate",
				merged: "Merged",
				paid: "Paid",
				received: "Received",
				rejected: "Rejected",
			},
			supplier: "Supplier",
			take_back_decision: "Take back decision",
			take_rest: "Take the rest",
			tax_ids: "VAT ID / Tax Number",
			tax_number: "Tax Number",
			top_suppliers: "Top Suppliers",
			unit: "Unit",
			unit_price: "Unit Price",
			vat_amount: "VAT",
			vat_id: "VAT ID",
			vat_rate: "VAT Rate",
		},
		invoices: {
			add_invoice: "Add Invoice",
			all_invoices: "All Invoices",
			calculated_to: "Calculated to",
			creation_date: "Creation Date",
			delete_invoice_cofirm_message:
				"Are you sure you want to delete this invoice? This action cannot be undone.",
			edit_invoice: "Edit Invoice",
			final_invoice: "Final Invoice",
			invoice: "Invoice",
			invoices: "Invoices",
			note: "Note",
			number: "Invoice-Number",
			overdue: "Overdue",
			paid: "Paid",
			pending: "Pending",
			progress_invoice: "Progress Invoice",
			progress_invoice_number: "Sequential Number",
			single_invoice: "Single Invoice",
			state: "State",
			sum_gross: "Sum (gross)",
			sum_net: "Sum (net)",
			type: "Type",
			not_found: "This invoice no longer exists.",
		},
		legal: {
			imprint: "Imprint",
			privacy_policy: "Privacy Policy",
			terms_and_conditions: "Terms and Conditions",
			terms_of_service: "Terms of Service",
			terms_of_use: "Terms of Use",
			legal_information: "Legal Information",
		},
		localization: {
			al: "Albanian",
			changed_language: "Changed language",
			de: "German",
			en: "English",
			fr: "French",
			language: "Language",
			pl: "Polish",
			ro: "Romanian",
			sk: "Slovak",
			suggest_better_translation: "Suggest a better translation",
			suggest_better_translation_description: `
				Please help us improve the translation for this text by suggesting a better translation.
				We appreciate your help!
			`,
			current_translation: "Current Translation",
			suggested_translation: "Suggested Translation",
			tr: "Turkish",
		},
		mailboxes: {
			add_mailbox: "Connect mailbox",
			attachments: "Attachments",
			connected: "Connected",
			connection: "Connection",
			custom_preset: "Other provider (enter manually)",
			delete_mailbox_confirm_message:
				"Disconnect this mailbox? Polling stops and its password is deleted. Emails already stored stay.",
			edit_mailbox: "Edit mailbox",
			email_address: "Email address",
			email_count: "Emails",
			emails: "Emails",
			emails_of: "Emails in {label}",
			errors: {
				duplicate: "This mailbox is already connected for this purpose",
				host_refused: "This server does not connect to that host",
				login_refused: "The mail server refused the login — check username and password",
				rate_limited: "Too many connection checks — wait a minute and try again",
				unreachable: "The mail server could not be reached",
			},
			every_n_minutes: "Every {count} minutes",
			folder: "Folder",
			from: "From",
			from_email: "From (email)",
			health: "Status",
			health_state: {
				failing: "Failing",
				needs_attention: "Needs attention",
				ok: "OK",
			},
			imap_host: "IMAP server",
			imap_port: "Port",
			imap_security: "Encryption",
			imap_username: "Username",
			is_paused: "Paused",
			label: "Label",
			last_error: "Last error",
			mailbox: "Mailbox",
			last_polled_at: "Last checked",
			last_succeeded_at: "Last success",
			mailboxes: "Mailboxes",
			never: "Never",
			no_attachments: "No attachments",
			no_emails_yet: "No emails fetched yet",
			not_found: "This mailbox no longer exists.",
			note: "Note",
			outcome: {
				failed: "Failed",
				skipped: "Skipped",
				stored: "Stored",
			},
			password: "Password",
			password_unchanged_hint: "Leave empty to keep the current password",
			poll_enqueued: "Fetching — the list updates in a moment",
			poll_now: "Fetch now",
			polling_interval: "Polling interval",
			preset: "Provider",
			processing: "Processing",
			processing_state: {
				completed: "Completed",
				failed: "Failed",
				queued: "Queued",
				skipped: "Skipped",
				started: "Processing",
			},
			received_at: "Received",
			security: {
				starttls: "STARTTLS (port 143)",
				tls: "TLS (port 993)",
			},
			show_emails: "Show emails",
			subject: "Subject",
		},
		maps: {
			map: "Map",
			maps: "Maps",
			open_google_maps: "Open Google Maps",
		},
		mentions: {
			type_to_find_member_or_project: "Type to find member or project",
		},
		misc: {
			scale: "Scale",
			command_view: "Command View",
			cumulative: "Cumulative",
			sum: "Sum",
			scan_qr_code: "Scan QR code",
			scan_barcode: "Scan barcode",
			scanning_documents: "Scanning documents...",
			vibration: "Vibration",
			selected_n_out_of_m: "Selected {n}/{m}",
			clear_cache: "Clear cache",
			monospaced: "Monospaced",
			send_email: "Send Email",
			no_email_available: "No email available",
			call: "Call",
			share: "Share",
			area_type: "Area Type",
			go_to_top: "Go to top",
			charts: {
				basis: "Basis",
				basisClosed: "Basis Closed",
				basisOpen: "Basis Open",
				bump: "Bump",
				bumpX: "Bump Horizontal",
				bumpY: "Bump Vertical",
				linear: "Linear",
				linearClosed: "Linear Closed",
				monotone: "Monotone",
				monotoneX: "Monotone Horizontal",
				monotoneY: "Monotone Vertical",
				natural: "Natural",
				step: "Step",
				stepAfter: "Step After",
				stepBefore: "Step Before",
			},
			misc: "Misc",
			pagination: {
				items: "Items",
				next: "Next",
				of: "of",
				page: "Page",
				previous: "Previous",
			},
			position: "Position",
			stacked: "Stacked",
			add_line: "Add Line",
			add_block: "Add Block",
			regions: {
				region: "Region",
				bw: "Baden-Württemberg",
				by: "Bavaria",
				be: "Berlin",
				bb: "Brandenburg",
				hb: "Bremen",
				he: "Hesse",
				hh: "Hamburg",
				mv: "Mecklenburg-Vorpommern",
				ni: "Lower Saxony",
				nw: "North Rhine-Westphalia",
				rp: "Rhineland-Palatinate",
				sl: "Saarland",
				sn: "Saxony",
				st: "Saxony-Anhalt",
				sh: "Schleswig-Holstein",
				th: "Thuringia",
			},
		},
		navigation: {
			dashboard: "Dashboard",
			fleet: "Fleet",
			my_space: "My Space",
			partners: "Partners",
			planning: "Planning",
			projects: "Projects",
			sidebar_layout: "Sidebar Layout",
			topbar_layout: "Topbar Layout",
			layout: "Layout",
		},
		notes: {
			quick_note: "Quick Note",
			add_note: "Add note",
			answers: "Answers",
			delete_confirmation_message:
				"Are you sure you want to delete this note? This action cannot be undone.",
			edit_note: "Edit note",
			edited: "Edited",
			note: "Note",
			notes: "Notes",
			note_is_empty: "A note needs either a comment or at least one file.",
			no_access: "You cannot see the notes here.",
			reply: "Reply",
			unmark_as_reply: "Unmark as reply",
			mentioned_you_title: "{name} mentioned you",
			mentioned_you_message: "{name} mentioned you in a note on {parent}",
			kinds: {
				project: "Project",
				contact: "Contact",
				order: "Order",
				partnership: "Partnership",
				service: "Service",
				diary_entry: "Diary entry",
				protocol: "Protocol",
				return_order: "Return order",
				calculation_item: "Calculation position",
				calculation: "Calculation",
				picking_round: "Picking round",
				substitution_plan: "Substitution plan",
				assignment: "Assignment",
				transfer_carrier: "Transfer carrier",
				user: "User",
				vehicle: "Vehicle",
				warehouse_zone: "Warehouse zone",
				wiki_page: "Wiki page",
				incoming_invoice: "Incoming invoice",
			},
			details: {
				crew: "Crew",
				zone: "Zone",
				position: "Position",
			},
		},
		integrations: {
			internal: "Internal",
			external: "External",
			webfleet: "Webfleet",
			personio: "Personio",
			personio_sync_role: "Role for synced people",
			personio_sync_role_description:
				"People the Personio sync creates start with this role. Without one, the sync refuses.",
			webfleet_auto_integration: "Webfleet (Auto-Integration)",
			suite: "Suite",
			integrations: "Integrations",
			integration: "Integration",
			integration_not_active: "Integration is not active",
			integration_is_active: "Integration is active",
			setup_integration: "Setup Integration",
			deactivate_integration: "Deactivate Integration",
			deactivate_integration_confirmation:
				"Are you sure you want to deactivate this integration? This action cannot be undone. To reactivate the integration, you will need to set it up again.",
			dont_worry: "Don't worry",
			we_store_your_api_credentials_securely:
				"Your API credentials will be stored securely encrypted and used only to authenticate requests to the Integration API.",
			integrated_at: "Integrated at {date}",
			integration_type: "Integration Type",
			connected: "Connected",
			connect: "Connect",
			disconnect: "Disconnect",
			not_connected: "Not connected",
			state: "State",
			confirm_message_disconnect_integration:
				"Are you sure you want to disconnect this integration?",
			no_integrations_found: "No integrations found",
			checking_active_integration: "Checking active integration...",
			state_both: "Fully integrated",
			state_internal: "Internal data available",
			state_external: "External data available",
			synchronize_n_with_webfleet: "Synchronize {count} vehicles with Webfleet",
			send_user_credentials_to_me: "Send user credentials to me in copy.",
			personio_no_active_integration: "Your account is not connected to Personio.",
			personio_sync: {
				title: "Sync with Personio",
				sync_n_people: "Sync {count} people",
				name: "Name",
				email: "Email",
				status: "Status",
				member: "Member",
				note: "Note",
				result: "Result",
				states: {
					linked: "Linked",
					link: "Link",
					create: "Create account",
					adopt: "Take over account",
					blocked: "Blocked",
				},
				matched_by_email: "Member with the same email address",
				matched_by_name: "Member with the same name",
				chosen_by_hand: "Member chosen by hand",
				new_account: "No account yet — created, sign-in details by mail",
				existing_account: "Account without an organisation exists — taken over, no mail",
				link_member: "Link to a member…",
				link_member_title: "Link {name} to a member",
				create_account_instead: "Create an account instead",
				reset_suggestion: "Back to the suggestion",
				outcomes: {
					linked: "Linked",
					created: "Account created",
					adopted: "Account taken over",
					failed: "Failed",
				},
				email_not_sent:
					'The welcome mail could not be sent. The person can use "Forgot password" on the sign-in page.',
				adopted_hint:
					'The person keeps their existing password. "Forgot password" on the sign-in page sets a new one.',
				summary_title: "Sync finished",
				summary: "{created} created, {adopted} taken over, {linked} linked, {failed} failed",
				teams_not_synced_title: "Teams not updated",
				teams_not_synced:
					"The teams could not be updated from Personio. Run the team sync in the team settings.",
				no_sync_role_title: "No role for synced people",
				no_sync_role_description:
					"Set the role for synced people in the Personio integration settings before accounts are created. Linking existing members works without it.",
				not_permitted_title: "Only owners and admins create accounts",
				not_permitted_description:
					"Creating an account hands out a role. You can still link Personio people to existing members.",
				already_running:
					"A Personio sync is already running for this organisation. Wait until it has finished.",
				issues: {
					missing_email: "Personio has no email address for this person",
					email_in_use: "The email address already belongs to another account",
					ambiguous_match: "Several members match by name — choose one by hand",
					no_sync_role: "No role is set for synced people",
					not_permitted: "Only owners and admins can create accounts",
					not_in_personio: "Not among the active people in Personio",
					not_a_member: "The chosen member does not belong to the organisation",
					member_linked_elsewhere: "The member is already linked to another Personio person",
					person_linked_elsewhere: "The person is already linked to another member",
					duplicate_selection: "Chosen twice in this sync",
					unexpected: "Unexpected error",
				},
			},
			integration_not_found: "This integration is no longer set up.",
			identifier_already_linked:
				"The external ID {identifier} is already linked to another record. Each external ID can only be linked once.",
			personio_credentials_invalid:
				"Personio did not accept the Client ID or Secret. Check your credentials and try again.",
			personio_credentials_rejected:
				"Personio no longer accepts the organization's credentials. Set up the Personio integration again.",
			personio_unavailable:
				"Personio did not answer every request. Nothing was changed — try again in a minute.",
		},
		organization: {
			business_hours: "Business hours",
			business_hours_hint:
				"An incoming invoice counts as received when the office next opens: an email that arrives outside these hours, on a closed day or on a public holiday is received at the next opening.",
			business_hours_organization_hint:
				"Every workspace without business hours of its own follows these.",
			business_hours_inherited_hint:
				"This workspace follows the organisation's business hours. Switch on its own hours to set different ones.",
			own_business_hours: "Own business hours",
			business_hours_closed: "Closed",
			reset_business_hours: "Reset to default",
			federal_state: "Federal state",
			federal_state_hint: "Public holidays of this state are skipped besides the nationwide ones.",
			bank_account: "Bank account",
			bank_account_hint:
				"Suppliers of invoices addressed to this workspace are paid from this account.",
			bank_account_holder: "Account holder",
			iban: "IBAN",
			bic: "BIC",
			worksites: "Worksites",
			automatic_break_buffer: "Automatic break buffer (minutes)",
			automatic_break_buffer_description:
				"A day up to this many minutes past 6 or 9 hours of work is cut back to the threshold instead of losing the full legal break.",
			worksite_required_acknowledgements: "Required Acknowledgements",
			worksite_acknowledgement_definitions: {
				add: "Add Acknowledgement",
				edit: "Edit Acknowledgement",
				delete_confirmation_message:
					"Are you sure you want to delete this acknowledgement? This action cannot be undone.",
			},
			join_organization: "Join Organization",
			join_organization_with_qr: "Join Organization with QR",
			join_organization_with_code: "Join Organization with Code",
			invitation_code_should_look_like: "Invitation Code should look like ABCD-1A2B3C4D",
			connecting_organization_failed: "Connecting to organization failed",
			cannot_partner_with_itself: "An organization cannot partner with itself.",
			connect_confirmation_title: "Connect as subcontractor",
			connect_confirmation_message: "{name} will then be able to book your crews.",
			already_connected_with: "You are already connected with {name}.",
			open_partner: "Open partner",
			copy_connect_link: "Copy link",
			show_qr_code: "Show QR code",
			share_connect_link: "Share link",
			open_in_app: "Open in app",
			connect_link_description:
				"Anyone who opens this link can become your subcontractor; the partnership stays pending until you activate it.",
			connect_organization_description:
				"Enter the partnership invitation code you received from the organization you want to partner with.",
			data: {
				unnamed_service: "Unnamed Service",
				hierachy: "Hierachy",
				data: "Data",
				service: "Service",
				services: "Services",
				add_service: "Add Service",
				add_custom_service: "Add Custom Service",
				select_service: "Select service",
				edit_service: "Edit Service",
				service_number: "Service Number",
				short_text: "Short Text",
				long_text: "Long Text",
				fulfillment_type: "Fulfillment Type",
				fulfillment_partners: "Fulfillment Partners",
				add_fulfillment_partner: "Add Fulfillment Partner",
				remove_fulfillment_partner: "Remove Fulfillment Partner",
				internal_service: "Internal Service",
				external_service: "External Service",
				parent_service: "Parent Service",
				atomic_number: "Atomic Number",
				delete_service_confirm:
					"Are you sure you want to delete this service? This action cannot be undone.",
				unit_price: "Unit Price",
				min_unit_price: "Min. Unit Price",
				max_unit_price: "Max. Unit Price",
				service_not_found: "This service no longer exists.",
			},
			add_workspace: "Add Workspace",
			company: "Company",
			create_organization: "Create Organization",
			edit_workspace: "Edit Workspace",
			logo: "Logo",
			members: "Members",
			organization: "Organization",
			organization_color: "Organization Color",
			organization_size: "Organization Size",
			organizations: "Organizations",
			settings: "Organization Settings",
			teams: "Teams",
			team: "Team",
			team_leaders: "Team Leaders",
			team_leader: "Team Leader",
			without_team: "No team",
			sync_teams_with_personio: "Sync Teams with Personio",
			team_has_no_members: "No members",
			team_capabilities: "Capabilities",
			add_team: "Add team",
			edit_team: "Edit team",
			delete_team: "Delete team",
			delete_team_confirmation:
				"Are you sure you want to delete this team? This action cannot be undone.",
			delete_personio_team_confirmation:
				"Are you sure you want to delete this team? Syncing with Personio will not create it again. This action cannot be undone.",
			invitation_codes: "Invitation Codes",
			partnership_invitation_code: "Partnership Invitation Code",
			partnership_invitation_code_description:
				"Share this code with the admin of the organization you want to connect with.",
			workspace: "Workspace",
			workspace_not_found: "Workspace not found",
			workspaces: "Workspaces",
			workspace_logo: "Logo",
			workspace_letterpaper: "Letterpaper",
			connect_organization: "Connect Organization",
			connected_organization: "Connected Organization",
			connected_organization_successfully: "Connected organization successfully",
			invite_organization: "Invite Organization",
			capabilities: {
				receive_substitution_list_copy: "Should receive the substitution list",
				crew_scheduling: "Can be assigned to a crew",
				vehicle_scheduling: "Can be assigned on a vehicle",
				manage_project: "Can manage or substitute a project",
				invoice_approval: "Can review incoming invoices",
			},
			activate_partnership: "Activate Partnership",
			deactivate_partnership: "Deactivate Partnership",
			not_found: "This organization no longer exists.",
			invalid_invitation_code: "This invitation code is not valid. Please check it and try again.",
			team_not_found: "This team no longer exists.",
			alert_not_found: "This alert no longer exists.",
			personio_not_connected: "Your organization is not connected to Personio.",
			personio_no_active_people:
				"Personio lists no active people, so the teams were left unchanged.",
		},
		partners: {
			notification_requested_title: "New partnership request",
			notification_requested_message:
				"{name} redeemed your partnership code. Activate the partnership to schedule their crews.",
			notification_activated_title: "Partnership activated",
			notification_activated_message:
				"{name} activated the partnership and can schedule your crews from now on.",
			notification_deactivated_title: "Partnership deactivated",
			notification_deactivated_message:
				"{name} deactivated the partnership. No further bookings until it is activated again.",
			role: "Role",
			role_subcontractor: "Subcontractor",
			role_client: "Client",
			direction_we_book: "We book {name}",
			direction_they_book: "{name} books us",
			partner_reports_email: "Partner Reports Email",
			add_agreement_as_follow_up_agreement: "Add Agreement as Follow-Up Agreement",
			add_booking: "Add Booking",
			add_bookings: "Add Bookings",
			review_bookings: "Review Bookings",
			submit_bookings: "Submit Bookings",
			submit_bookings_short: "Submit",
			review_bookings_short: "Review",
			all_bookings: "All Bookings",
			nothing_open_this_week: "Nothing is open this week",
			nothing_this_week: "No bookings this week",
			filter_bookings: "Filter bookings",
			only_open_bookings: "Open only",
			n_open_booking_reviews: "{count} open booking reviews",
			n_required_bookings: "{count} required bookings",
			agreement_date_taken: "Agreement date taken",
			agreement_date_taken_description:
				"The selected date is already taken by another agreement of the same type. Please select a different date or click here to edit existing agreements.",
			agreement_missing: "Agreement missing",
			agreements: "Agreements",
			bookings: "Bookings",
			start: "Start",
			end: "End",
			control_bookings: "Control Bookings",
			controlled_hours: "Controlled Hours",
			early_payment_discount: "Early Payment Discount",
			early_payment_discount_payment_target: "Early Payment Discount - Payment Target",
			hourly: "Hourly",
			hourly_rate: "Hourly Rate",
			hourly_total: "Hourly Total",
			my_partners: "My Partners",
			partner: "Partner",
			partners: "Partners",
			pause: "Pause",
			payment_target: "Payment Target",
			service: "Service",
			total: "Total",
			service_total: "Service Total",
			settlement_sum: "Settlement Sum",
			submitted_sum: "Submitted Sum",
			approve_booking: "Approve",
			accept_booking: "Accept",
			accepted_booking: "Accepted",
			approved_reference_hint: "This booking has been approved and can no longer be edited.",
			reject_booking: "Reject",
			rejected_booking: "Rejected",
			adjusted_booking: "Adjusted",
			submitted_hours: "Submitted Hours",
			valid_from: "Valid from",
			valid_until: "Valid until",
			host: "Host",
			send_report: "Send report",
			sending_report: "Sending report",
			report_sent: "Report sent",
			report_failed: "Report failed",
			send_copy_to_myself: "Send copy to myself",
			uncaluclated: "Uncaluclated",
			uncalculated_references_warning:
				"This week has uncalculated references. Are you sure you want to send the report?",
			reports: {
				report: "Report",
				reports: "Reports",
				report_number: "Report Number",
				invoice_tracking: "Invoice Tracking",
				last_sent: "Last sent",
				last_sent_by: "Last sent by",
				last_sent_at: "Last sent at",
			},
			booking_state: {
				open: "Open",
				submitted: "Submitted",
				reviewed: "Reviewed",
				approved: "Approved",
			},
			partnership_not_found: "This partnership no longer exists.",
			not_a_member: "Your organization is not part of this partnership.",
			agreement_not_found: "This agreement no longer exists.",
			reference_not_found: "This booking no longer exists.",
			report_reference_not_found: "This report no longer exists.",
			only_host_can_approve_bookings: "Only the host organization can approve bookings.",
			only_host_can_change_calculation_type:
				"Only the host organization can change how a booking is billed.",
			nothing_to_update: "There are no changes to save.",
			no_person_named: "No person named",
			remove_booking: "Remove booking",
			not_reviewed_yet: "Not checked yet",
			day_not_published:
				"No plan has been published for this day yet. Hours can be booked once it is published.",
			reference_approved:
				"This booking has been approved and takes no further changes. Withdraw the approval to change its hours.",
			bookings_changed:
				"These bookings were changed by someone else while you had them open. Reload them to see the current state.",
			bookings_changed_title: "Bookings changed in the meantime",
			bookings_changed_description:
				"Someone else changed these bookings while you had them open. Reloading shows the current state and discards your unsaved changes here.",
			reload_bookings: "Reload bookings",
			withdraw_approval_title: "Withdraw approval?",
			withdraw_approval_message:
				"The bookings become editable again for both sides, and the record has to be approved again before it is settled.",
			withdraw_approval: "Withdraw approval",
		},
		personnel: {
			absence: "Absence",
			absences: "Absences",
			absence_is_not_editable: "Absence is not editable",
			employees: {
				absences: "Absences",
				employee: "Employee",
				employees: "Employees",
			},
			events: "Events",
			fields: {
				email: "E-Mail",
				phone: "Phone",
				position: "Position",
				web: "Web",
			},
			personnel: "Personnel",
			employment: {
				job_title: "Job title",
				valid_from: "Valid from",
				valid_to: "Valid to",
				employment: "Employment",
				add_employment: "Add Employment",
				edit_employment: "Edit Employment",
				no_employment_available: "No Employment available",
				hours_per_week: "Hours per week",
			},
		},
		placeholders: {
			estimated_days: "e.g. 3",
			add_note: "Add a useful note...",
			select_member: "Select a member...",
			city: "Berlin",
			company_name: "ACME Scaffolding Ltd.",
			email: "max@mustermann.de",
			first_name: "Max",
			house_number: "13a",
			invoice_number: "INV-0001",
			last_name: "Mustermann",
			organization: "ACME Corp.",
			phone: "+49 123 456789",
			// Plain Date on purpose: date/moment.ts imports the locales barrel, so importing the
			// wrapped moment here closes an ESM cycle that crashes whichever consumer happens
			// to evaluate the date module first.
			project_number: `${new Date().getFullYear().toString().slice(-2)}-0123`,
			search: "Search...",
			search_n_results: "Search {count} results...",
			street: "Mozartstraße",
			ticket_name: "8000m² SL100",
			title: "Title",
			description: "Add description...",
			text: "Enter text...",
			type_to_add: "Type to add...",
			zip_code: "13158",
			web: "https://www.acme.com",
			resource_link_name: "Trimble model",
			username: "max.mustermann",
			short_text: "Gerüstplanung Fassadengerüst",
			long_text:
				"Gerüstplanung des Fassadengerüstes, einschl. erforderlicher Ausführungszeichnungen für Konstruktionen außerhalb der DIN- und Herstellervorschrift...",
			select_service: "Select service...",
			calculation_name: "Offer for ACME Corp.",
			team_name: "Accounting",
			role_name: "Site management",
			stock: {
				article_group_name: "Systemfrei",
				article_product_type_name: "Kupplung/Rohrverbinder",
				article_name: "Normalkupplung",
				order_template_name: "Sample Order Template",
				tour_name: "Early Morning Rush",
				vendor_article_number: "5FSNN60001",
				warehouse_zone_name: "Hall A",
			},
			employment: {
				job_title: "Technician",
			},
		},
		planning: {
			number_of_weeks: "Number of weeks",
			calendar_weeks_count: "{count} weeks",
			change_not_allowed: "That change was not allowed",
			rules_could_not_be_loaded: "Your permissions could not be loaded",
			mark_all_tickets_as_skipped: "Mark all tickets as skipped",
			assign_user: "Assign user",
			show_vehicles: "Show Vehicles",
			active: "Active",
			collapse_all_days: "Collapse all days",
			copy_day: "Copy day",
			notify_about_changes: "Notify about changes",
			crews_on_partner_board: "Our crews on a partner's board",
			copying_day: "Copying day",
			resources: "Resources",
			daily_planning: "Daily planning",
			capacity_planning: "Capacity planning",
			capacity_view_manager: "Managers",
			other_managers: "Other managers",
			capacity_view_planner: "Capacity planner",
			calendar_week_short: "CW {week}",
			empty_day_label: "Add crew or copy a day to start",
			hide_tickets: "Hide tickets",
			show_tickets: "Show tickets",
			plan_published: "Plan published",
			plan_updated: "Plan updated",
			name_has_updated_the_plan_for: "{name} has updated the plan for {company} on {date}",
			name_has_published_the_plan_for: "{name} has published the plan for {company} on {date}",
			publish_plan: "Publish plan",
			unpublish_plan: "Unpublish plan",
			no_history_yet: "No history yet",
			crews: {
				tickets_count: "{count} tickets",
				estimated_days_count: "{count} days",
				no_work_in_window: "Nothing scheduled in these weeks",
				edit_manager_slot: "Edit manager slot",
				no_manager_slots: "No manager slots on this crew",
				my_manager_slots: "My manager slots",
				no_manager_slots_in_window: "You hold no crews in these weeks",
				manager_slot_manager: "Manager",
				schedule_crew: "Schedule crew",
				outside_manager_slot: "You do not hold this crew for those days",
				crew_not_active_yet: "This crew does not exist yet on those days",
				crew_already_ended: "This crew has ended before those days",
				crew_does_not_work_those_days: "This crew does not work every day of that span",
				work_does_not_fit_window: "{{count}} day(s) more than the window holds",
				add_work_break: "Add break…",
				scheduled_crew: "Crew",
				scheduled_from: "On site from",
				scheduled_until: "On site until",
				no_crew_scheduled: "No crew scheduled",
				manager_slot_start_date: "Holds from",
				manager_slot_end_date: "Holds until",
				add_manager_slot: "Add manager slot",
				crew_has_no_members: "No members yet",
				crew_partner_helper_text:
					"A partner's crew is staffed by the partner, so no employees are picked here.",
				staffing_conflict_title: "Someone is booked on another crew",
				staffing_conflict_line: "{user} is already on {crew} from {from} to {to}",
				unnamed_crew: "Unnamed crew",
				add_crew_definition: "Add crew",
				add_crew_member: "Add member",
				no_crews_in_window: "No crews active in these weeks",
				edit_crew_definition: "Edit crew",
				crew_name_placeholder: "e.g. Crew North",
				crew_start_date: "Active from",
				crew_end_date: "Active until",
				crew_members: "Crew members",
				crew_lead: "Foreman",
				make_crew_lead: "Make foreman",
				crew_member_count: "{count} members",
				add_crew: "Add crew",
				assign_crew: "Assign crew",
				copy_crew: "Copy crew",
				crew: "crew",
				crew_added: "crew added",
				crews: "crews",
				crews_title: "Crews",
				delete_crew: "Delete crew",
				own_crew: "Own crew",
				remove_from_crew: "Remove from crew",
			},
			editing: "Editing",
			inactive: "Inactive",
			pending: "Pending",
			published: "Published",
			unpublished: "Unpublished",
			drag_ticket_here: "Drag ticket here",
			drag_user_here: "Drag user here",
			drag_vehicle_here: "Drag vehicle here",
			day_not_published_yet: "Day not published yet",
			add_to_crew: "Add to {crew}",
			add_item_one: "Add 1 item",
			add_items_count: "Add {count} items",
			plan_not_found: "This plan no longer exists.",
			plan_not_editable: "This day is published and can no longer be changed. Unpublish it first.",
			day_to_copy_not_found: "There is no plan on the day you want to copy.",
			crew_not_found: "This crew no longer exists.",
			crew_organisation_not_partner: "This organisation is not one of your partners.",
			crew_staffed_by_owner_only: "Only the organisation that owns this crew can staff it.",
			assignment_not_found: "This entry is no longer on the board.",
			crew_does_not_work_on: "This crew does not work on {date}.",
			schedule_outside_ticket_window: "A crew can only be scheduled inside the ticket's window.",
			manager_slot_not_found: "This manager slot no longer exists.",
			manager_slot_before_crew: "A manager slot cannot begin before its crew does.",
			manager_slot_after_crew_ended: "A manager slot cannot begin after its crew has ended.",
			manager_slot_outlasts_crew: "A manager slot cannot run past the end of its crew.",
			partner_crew_has_no_employees:
				"A partner's crew is staffed by the partner and cannot include your employees.",
			partner_crew_has_no_vehicles: "A partner's crew cannot be given one of your vehicles.",
			member_cannot_be_scheduled:
				"Someone in this crew is not on a team that can be assigned to crews.",
		},
		profile: {
			avatar: "Avatar",
			first_name: "First Name",
			invalid_push_token: "The push token is not a valid Expo token.",
			full_name: "Full Name",
			last_name: "Last Name",
			initials: "Intials",
			mr: "Mr.",
			mrs: "Mrs.",
			profile: "Profile",
			profile_settings: "Profile Settings",
			change_profile_picture: "Change profile picture",
			choose_from_library: "Choose from library",
			take_photo: "Take photo",
			title: "Title",
			email_verified: "Email verified",
		},
		roles: {
			roles: "Roles",
			role: "Role",
			member_count: "People",
			no_members: "Nobody",
			protected_hint: "Fixed, cannot be changed.",
			create_role: "Create role",
			rename_role: "Rename role",
			duplicate_role: "Duplicate role",
			delete_role: "Delete role",
			delete_confirmation_message:
				"This role will be deleted. {count} people lose the permissions it grants, immediately and without a replacement.",
			name_taken: "A role with this name already exists.",
			not_found: "This role no longer exists.",
			copy_suffix: "{name} (copy)",
			member_added: "Added to the role.",
			member_removed: "Removed from the role.",
			add_member: "Add member",
			no_members_left: "Everyone already carries this role.",
			scope_none: "No access",
			scope_organization: "Everything",
			scope_own: "Only their own",
			scope_own_projects: "Only their own projects",
			scope_custom: "Custom",
			scope_combined: "Combined from roles",
			scope_explanation_none: "This action is not permitted.",
			scope_explanation_organization: "Every record in the organisation.",
			scope_explanation_own_records: "Only records concerning the person themselves.",
			scope_explanation_own_created: "Only records the person created themselves.",
			scope_explanation_own_projects:
				"Only in projects where the person is entered as manager or deputy, or is currently covering an active substitution.",
			scope_explanation_custom: "Custom conditions — not editable here.",
			scope_explanation_combined: "Combined from the reaches of several roles.",
			admin_not_editable: "The admin role always holds every permission and cannot be changed.",
			members_locked:
				"Everyone in the organisation is a member. Nobody can be removed from this role.",
			added_at: "Added on",
			added_by: "Added by",
			remove_member: "Remove from role",
			remove_member_confirmation:
				"{name} will lose the permissions this role grants — immediately and without a replacement.",
			activate: "Activate",
			deactivate: "Deactivate",
			deactivate_confirmation:
				"The role {role} will be deactivated for this user — its permissions are revoked immediately.",
			member_always_active: "Everyone is a member — this role cannot be deactivated.",
			owner_not_assignable: "The owner already has full access. Roles cannot be assigned to them.",
		},
		projects: {
			manager_assigned_title: "Assigned as site manager",
			manager_assigned_message: "{name} made you the site manager of {number} {project}.",
			number_changed_title: "Project number changed",
			number_changed_message: "{name} changed the number of {project} to {number}.",
			estimated_days: "Estimated days",
			estimated_days_exceeds_span: "This window holds only {count} working days",
			estimated_days_helper_text:
				"How many days of work the ticket takes, inside the window above.",
			no_project: "No project",
			active_projects_one: "1 active project",
			active_projects_count: "{count} active projects",
			select_project: "Select Project",
			change_project: "Change Project",
			project_search: "Project search...",
			nearby_search: "Nearby search",
			project_information: "Project Information",
			ticket_information: "Ticket Information",
			open_project: "Open Project",
			project_settings: "Project Settings",
			invoicing_period: "Invoicing Period",
			invoicing_period_description: "The period for which progress invoices are required",
			last_invoice: "Last Invoice",
			next_possible_invoice: "Next possible invoice",
			has_final_invoice: "Has final invoice",
			has_progress_invoice: "Has progress invoice",
			has_single_invoice: "Has Single invoice",
			no_invoices_yet: "No invoices yet",
			no_invoice_yet: "No invoice yet",
			_created_this_project: "created this project",
			_system_created_this_project: "Project has been created",
			_system_updated_this_project: "System updated this project",
			_updated_this_project: "updated this project",
			_updated_this_project_without_changes: "updated this project without changes",
			_merged_project_into_this_project: "merged {projectName} into this project",
			activate_ticket: "Activate Ticket",
			add_project: "Add Project",
			add_ticket: "Add Ticket",
			new_tickets: "New Tickets",
			all_projects: "All Projects",
			preferred_projects: "Preferred Projects",
			archive_ticket: "Archive Ticket",
			assign_ticket: "Assign Ticket",
			copy_ticket: "Copy Ticket",
			current_projects: "Current Projects",
			deactivate_project: "Deactivate Project",
			deactivate_ticket: "Deactivate Ticket",
			edit_project: "Edit Project",
			edit_ticket: "Edit Ticket",
			delete_project: "Delete Project",
			delete_project_description:
				"Permanently delete project and all associated data. This action cannot be undone. Alternatively you can set this project to inactive state to keep the data and hide it from the project list.",
			merge_project: "Merge Project",
			merge_project_description:
				"Merge this project with another project. This will move all data from this project to the selected project. This action cannot be undone.",
			merge_project_select: "Select Project to Merge With",
			merge_project_direction: "Merge Direction",
			merge_project_direction_source_to_target: "Source to Target",
			merge_project_direction_source_to_target_description:
				"All data from this project will be moved to the selected project. The selected project will be the target project.",
			merge_project_direction_target_to_source: "Target to Source",
			merge_project_direction_target_to_source_description:
				"All data from the selected project will be moved to this project. This project will be the target project.",
			merge_project_target_cannot_be_same_as_source:
				"Target project cannot be the same as source project. Please select a different project.",
			merging_projects: "Merging Projects...",
			delete_project_confirm_message:
				"Are you sure you want to delete this project? This action cannot be undone. This also affects all data associated with this project.",
			fields: {
				client: "Client",
				manager: "Manager",
				deputy_managers: "Deputy Managers",
				project_name: "Project Name",
				project_number: "Project Nr.",
				related_project: "Related Project",
				number: "Number",
				select_member: "Select Member",
			},
			entries: "Entries",
			my_projects: "My Projects",
			project: "Project",
			project_acitivity: "Project Activity",
			projects: "Projects",
			state: {
				active: "Active",
				archived: "Archived",
				inactive: "Inactive",
			},
			ticket_date: "Ticket Date",
			ticket_type: "Ticket Type",
			ticket_types: "Ticket Types",
			ticket_type_not_found: "Ticket type not found",
			ticket_not_found: "This ticket no longer exists.",
			ticket_reference_not_found: "This ticket refers to something that no longer exists.",
			ticket: "Ticket",
			tickets: "Tickets",
			create_diary: "Create Diary",
			include_in_diary: "Include in Diary",
			include_note_in_diary: "Include note in diary",
			include_notes_in_diary: "Include notes in diary",
			include_media_in_diary: "Include media in diary",
			include_unpublished_assignments_in_diary: "Include unpublished assignments in diary",
			note_is_included_in_diary: "Note is included in diary",
			create_diary_asc: "Oldest day first",
			create_diary_desc: "Newest day first",
			generate_project_summary: "Generate Project Summary",
			click_here_to_generate_project_summary:
				"Click here to generate a project summary. This will take a few seconds.",
			regenerate_project_summary: "Regenerate Project Summary",
			project_summary: "Project Summary",
			remove_contact_from_project: "Remove contact from project",
			remove_contact_from_project_confirm_message:
				"Are you sure you want to remove this contact from the project? This action cannot be undone.",
			remove_member_from_project: "Remove member from project",
			remove_member_from_project_confirm_message:
				"Are you sure you want to remove this member from the project? This action cannot be undone.",
			edit_contact_project_override: "Edit contact for project",
			reset_contact_project_override: "Reset contact to original",
			reset_contact_project_override_confirmation:
				"Are you sure you want to reset this contact to the original? This will remove all project-level overrides.",
			edit_member_project_override: "Edit member for project",
			reset_member_project_override: "Reset member to original",
			reset_member_project_override_confirmation:
				"Are you sure you want to reset this member to the original? This will remove all project-level overrides.",
			not_found: "This project no longer exists.",
			name_workspace_address_required: "A project needs a name, a workspace and an address.",
			related_project_not_found: "The linked project no longer exists.",
			invoice_project_mismatch: "This invoice belongs to a different project.",
			staff_not_a_member: "One of the selected people is no longer a member of the organisation.",
			staff_not_active:
				"One of the selected people is no longer an active member of the organisation.",
			timeline_note_not_found: "This timeline note no longer exists.",
			contact_not_assigned: "This contact is no longer assigned to the project.",
			contact_member_not_assigned: "This contact person is no longer assigned to the project.",
			ticket_window_too_short_for_estimate:
				"The ticket's estimated working days would no longer fit into its period.",
		},
		vehicles: {
			ignition: "Ignition",
			ignition_on: "Ignition On",
			ignition_off: "Ignition Off",
			speed: "Speed",
			driver_name: "Driver Name",
			orders: "Orders",
			cranes: "Cranes",
			elevators: "Elevators",
			vehicles: "Vehicles",
			vehicle: "Vehicle",
			start: "Start",
			destination: "Destination",
			add_vehicle: "Add Vehicle",
			select_vehicle: "Select vehicle",
			edit_vehicle: "Edit Vehicle",
			delete_vehicle: "Delete Vehicle",
			width: "Width",
			height: "Height",
			depth: "Depth",
			license_plate: "License Plate",
			vin: "VIN",
			manufacturer: "Manufacturer",
			hsn: "HSN",
			tsn: "TSN",
			fuel_type: "Fuel Type",
			first_registration: "First Registration",
			flatbed: "Flatbed",
			dimensions: "Vehicle Dimensions",
			maximum_load: "Maximum Load",
			maximum_load_kg: "Maximum Load (kg)",
			maximum_load_volume_m3: "Maximum Load Volume (m³)",
			front_crane: "Front Crane",
			tail_crane: "Tail Crane",
			angle: "Crane Angle",
			adc_kg: "ADC kg",
			weight_kg: "kg",
			meter: "m",
			crane_load: "Crane Load",
			add_crane_load: "Add Load Row",
			unknown_driver: "Unknown Driver",
			arrival: "Arrival",
			expected_arrival: "Expected Arrival",
			types: {
				car: "Car",
				other: "Other",
				pickup: "Pickup",
				trailer: "Trailer",
				truck: "Truck",
				van: "Van",
			},
			fuel_types: {
				diesel: "Diesel",
				petrol: "Petrol",
				electric: "Electric",
				hybrid: "Hybrid",
				other: "Other",
			},
			delete_vehicle_confirm_message:
				"Are you sure you want to delete this vehicle? This action cannot be undone.",
			connect_vehicle_to_webfleet_object: "Connect Vehicle to Webfleet Object",
			order_type: {
				delivery: "Delivery",
				pickup: "Pickup",
				service: "Service",
				unknown: "Unknown",
			},
			not_found: "This vehicle no longer exists.",
		},
		settings: {
			settings: "Settings",
		},
		spotlight: {
			action: "Action",
		},
		tables: {
			actions: "Actions",
			add_column: "Add column",
			add_row: "Add row",
			columns: "Columns",
			filtered_items: "Filtered items",
			visible_items: "Visible items",
			formatting_has_been_reset: "Formatting has been reset",
			hide_column: "Hide column",
			insert_column_left: "Insert column left",
			insert_column_right: "Insert column right",
			insert_row: "Insert row",
			insert_row_above: "Insert row above",
			insert_row_below: "Insert row below",
			insert_table: "Insert Table",
			items_per_page: "Items per page",
			merge_cells: "Merge cells",
			no_data_available: "No data available",
			no_data_available_for_current_filter: "No data available for current filter",
			pin: "Pin",
			pin_left: "Pin left",
			pin_right: "Pin right",
			remove_column: "Remove column",
			remove_row: "Remove row",
			reset_formatting: "Reset formatting",
			reset_sorting: "Reset sorting",
			show_column: "Show column",
			sort_ascending: "Sort ascending",
			sort_descending: "Sort descending",
			sorted: "Sorted",
			split_cells: "Split cells",
			total_items: "Total items",
			unpin: "Unpin",
			n_items_selected: "{count} items selected",
			move_column_left: "Move column left",
			move_column_right: "Move column right",
			show_grouping_header: "Show grouping header",
			fold_all: "Fold all",
		},
		substitutions: {
			summary: "Summary",
			substitutions: "Substitutions",
			substitution_plan: "Substitution Plan",
			no_assignment_required: "No cover required",
			assignment_not_required: "Cover not required",
			n_assigned: "{count} assigned",
			assign_substitutes: "Assign Substitutes",
			start_substitution_plan: "Start substitution plan",
			plan_not_started_yet: "This substitution plan has not been started yet.",
			submit_substitution_plan: "Submit substitution plan",
			collision_warning: "Some substitutes are absent during this period",
			is_expired: "Is Expired",
			notify_contacts: "Notify contacts",
			checking_for_collisions: "Checking for collisions",
			this_hint_is_only_internally_visible: "This hint is only internally visible",
			please_edit_all_projects: "Please edit all projects before submitting",
			please_edit_this_project: "Please edit this project",
			n_contacts_will_be_notified: "{count} contacts will be notified",
			notify: "Notify",
			dont_notify: "Don't notify",
			mute_all_contacts: "Mute all contacts",
			process_substitution_plan: "Process substitutionplan",
			show_unanswered_items_only: "Show unanswered items only",
			edit_substitution_plan: "Edit substitutionplan",
			send_notification_emails_on_a_later_date: "Send notification emails on a later date",
			finish_substitution_list: "Finish substitution list",
			show_summary: "Show summary",
			copy_previous_plan_message:
				"Do you want to copy the notes, assignments, and contacts from your previous substitution plan?",
			copy_previous_plan_confirm: "Copy previous plan",
			copy_previous_plan_reject: "Start blank",
			not_found: "This substitution plan no longer exists.",
		},
		tasks: {
			assignee: "Assignee",
			assignee_helper_text: "Select a user or partner to assign this task to.",
			task: "Task",
			tasks: "Tasks",
			n_tasks: "{count} Tasks",
		},
		theme: {
			accent: "Accent",
			amber: "Amber",
			azure: "Azure",
			blue: "Blue",
			color: "Color",
			cyan: "Cyan",
			dark: "Dark",
			"ember-blaze": "Ember Blaze",
			emerald: "Emerald",
			fern: "Fern",
			gray: "Gray",
			green: "Green",
			icon: "Icon",
			indigo: "Indigo",
			jade: "Jade",
			light: "Light",
			lime: "Lime",
			orange: "Orange",
			primary: "Primary",
			purple: "Purple",
			red: "Red",
			rose: "Rose",
			salmon: "Salmon",
			sky: "Sky",
			slate: "Slate",
			stone: "Stone",
			teal: "Teal",
			theme: "Theme",
			violet: "Violet",
			yellow: "Yellow",
			zinc: "Zinc",
			system: "System",
			use_system_theme: "Use system theme",
			using_system_theme: "You are now using the system theme.",
		},
		timeline: {
			timeline: "Timeline",
		},
		tiptap: {
			bold: "Bold",
			characters: "Characters",
			italic: "Italic",
			paragraph: "Paragraph",
			strikethrough: "Strikethrough",
			underline: "Underline",
		},
		units: {
			select_unit: "Select unit",
			piece: "Piece",
			piece_week: "Piece / Week",
			business_days: "Business Days",
			calendar_days: "Calendar Days",
			cubic_meters: "Cubic Meters",
			weeks: "Weeks",
			currency: "Currency",
			days: "Days",
			meters: "Meters",
			meters_week: "Meters / Week",
			number: "Number",
			percent: "Percent",
			square_meters: "Square Meters",
			square_meters_week: "m² / Week",
			unit: "Unit",
			work_days: "Work Days",
			flat_rate: "Flat Rate",
			centimeters: "Centimeters",
			millimeters: "Millimeters",
			kilometers: "Kilometers",
			hours: "Hours",
			gram: "Gram",
			grams: "Grams",
			kilogram: "Kilogram",
			kilograms: "Kilograms",
			ton: "Ton",
			tons: "Tons",
		},
		users: {
			add_user: "Add user",
			user_added: "User added.",
			select_user: "Select user...",
			invite_users: "Invite Users",
			my_profile: "My Profile",
			permission: "Permission",
			permissions: "Permissions",
			role: "Role",
			roles: "Roles",
			user: "User",
			user_does_not_exist: "User does not exist anymore",
			users: "Users",
			signed_up: "signed up",
			email_verified: "Email Verified",
			resend_verification_email: "Resend Verification Email",
			verification_email_sent: "Verification email sent",
			remove_user_from_organization: "Remove User from Organization",
			remove_user_from_organization_description:
				"Remove the user from the organization. This will remove the user from all projects and services.",
			remove_user_from_organization_successfully: "Successfully removed user from organization",
			remove_user_from_organization_confirm_message:
				"Are you sure you want to remove this user from the organization? Youc an later invite this user again.",
			set_active: "Set active",
			set_active_description:
				"Set the state of the user to active so that they appear in the users list by default and can be assigned to crews or projects.",
			set_inactive: "Set inactive",
			set_inactive_description:
				"Set the state of the user to inactive so that dont appear in the users list by default and can't be assigned to crews or projects. Also they won't be able to access the app in your organization anymore.",
			current_attendance: "Current Attendance",
			attendances: "Attendances",
			attendance_approvals: "Attendance Approvals",

			my_attendances: "My Attendances",
			not_started: "Not started",
			attendance: "Attendance",
			attendance_has_been_rejected: "{name} rejected your attendance",
			attendance_has_been_approved: "{name} approved your attendance",
			substitution_assigned_title: "You have been assigned as a substitute",
			substitution_assigned_message:
				"{name} is away from {from} to {to}. You cover for them during this time.",
			edit_attendance: "Edit attendance",
			worksite: "Worksite",
			current_worksite: "Current Worksite",
			new_worksite: "New Worksite",
			change_worksite: "Change Worksite",
			slide_to_start_attendance: "Slide to start attendance",
			slide_to_end_attendance: "Slide to end attendance",
			last_14_days: "Last 14 days",
			last_30_days: "Last 30 days",
			attendance_duration: "Duration",
			attendance_running: "Running",
			attendance_insights: "Insights",
			average_per_workday: "Ø per workday",
			days_worked: "Days worked",
			total_work: "Total work",
			average_break: "Ø break",
			off_schedule_work: "Off schedule",
			attendance_balance: "Balance",
			pending_entries: "Pending",
			missing_check_out_title: "Check-out missing",
			missing_check_out_description_one:
				"One day in the last 30 days holds an attendance that was never ended, so it counts as a day not worked.",
			missing_check_out_description_count:
				"{count} days in the last 30 days hold an attendance that was never ended, so they count as days not worked.",
			rejected_attendances_title: "Rejected entries",
			rejected_attendances_description_one:
				"One of your attendances was rejected. Correct it so its hours are counted.",
			rejected_attendances_description_count:
				"{count} of your attendances were rejected. Correct them so their hours are counted.",
			attendance_state: {
				pending: "Pending",
				approved: "Approved",
				rejected: "Rejected",
			},
			attendance_type: {
				work: "Work",
				break: "Break",
				automatic_break: "Automatic break",
			},
			add_attendance: "Add attendance",
			attendance_end_before_start: "The end has to be after the start",
			attendance_in_the_future: "An attendance can't lie in the future",
			attendance_overlaps_live: "The entry reaches into the attendance that is running right now",
			source_type: {
				web: "Web",
				mobile: "App",
				terminal: "Terminal",
				system: "Automatic",
			},
			worksite_type: {
				home_office: "Home Office",
				office: "Office",
				project_site: "Project Site",
				warehouse: "Warehouse",
				commute: "Commute",
			},
			reject_attendance_reason: "Reason",
			check_in: "Check in",
			check_out: "Check out",
			slide_to_check_in: "Slide to check in",
			slide_to_check_out: "Slide to check out",
			confirm_attendance: "Confirm Attendance",
			i_accept_the_risk_assessments: "I accept the risk assessments",
			risk_assessment: "Risk Assessment",
			risk_assessments: "Risk Assessments",
			required_acknowledgements: "Required Acknowledgements",
			acknowledgements_required: "The check-in requires acknowledgements that were not given.",
			acknowledged: "Acknowledged",
			not_acknowledged: "Not acknowledged",
			not_a_member: "This person is not a member of your organisation.",
			team_not_found:
				"One of the selected teams no longer exists. Reload the page and choose again.",
			owner_not_removable: "The owner cannot be removed from the organisation.",
			attendance_worksite_required: "Choose a worksite to check in.",
			no_live_attendance: "You are not checked in. Check in before changing the worksite.",
		},
		absences: {
			absence_approvals: "Absence Approvals",
			absence_calendar: "Absence Calendar",
			past: "Past",
			upcoming: "Upcoming",
			only_show_upcoming: "Only show upcoming",
			current: "Current",
			absences: "Absences",
			absence: "Absence",
			my_absences: "My Absences",
			absence_type: "Absence type",
			add_absence: "Add absence",
			edit_absence: "Edit absence",
			vacation_days: "Vacation days",
			default_vacation_days: "Default vacation days",
			vacation_days_expire: "Vacation days expire",
			vacation_days_expire_at: "Vacation day expire at",
			requires_document: "Requires document",
			requires_approval: "Requires approval",
			deducts_from_balance: "Deducts from balance",
			half_day: "Half day",
			delete_absences_confirm_message: "Are you sure you want to delete this absence?",
			absences_categories: "Absence categories",
			default_half_days: "Default half days",
			add_half_day: "Add half day",
			accrual_type: {
				accrual_type: "Accrual Type",
				accrual_type_description:
					"Monthly: Days accumulate each month. Upfront: All days are granted at the beginning of the year.",
				monthly: "Monthly",
				upfront: "Upfront",
			},
			category: {
				category: "Category",
				categories: "Categories",
				vacation: "Vacation",
				sick: "Sickness",
				leave: "Leave",
				compensation: "Compensation",
			},
			state: {
				pending: "Pending",
				approved: "Approved",
				rejected: "Rejected",
				cancelled: "Cancelled",
			},
			not_own: "You can only view and change your own absences.",
			not_found: "This absence no longer exists.",
			already_started:
				"This absence has already started and can no longer be changed or deleted. Please contact your administrator.",
		},
		visiblity: {
			private: "Private",
			public: "Public",
			restricted: "Restricted",
			visiblity: "Visibility",
		},
		wiki: {
			add_page: "Add Page",
			add_space: "Add Space",
			are_you_sure_you_want_to_delete_this_page:
				"Are you sure you want to delete this page? This action cannot be undone.",
			are_you_sure_you_want_to_delete_this_page_and_all_its_content:
				"Are you sure you want to delete this page and all its content and sub pages? This action cannot be undone.",
			are_you_sure_you_want_to_delete_this_space:
				"Are you sure you want to delete this space? This action cannot be undone. This also affects all pages in this space.",
			attach_file: "Attach file",
			copy_page: "Copy Page",
			created_on: "created on {date}",
			created_on_by: "created on {date} by {name}",
			delete_page: "Delete Page",
			delete_space: "Delete Space",
			edit_page: "Edit Page",
			edit_space: "Edit Space",
			files: "Files",
			last_edited: "last edited {time}",
			no_pages_yet: "No pages yet",
			no_spaces_available: "No spaces available",
			page: "Page",
			page_content: "Content",
			page_not_found: "This page no longer exists.",
			page_title: "Title",
			page_title_placeholder: "Enter page title...",
			pages: "Pages",
			save_as_template: "Save as Template",
			select_page: "Select Page",
			select_space: "Select a space",
			space: "Space",
			space_description: "Description",
			space_name: "Name",
			spaces: "Spaces",
			sub_pages: "Sub pages",
			untitled: "Untitled",
			wiki: "Wiki",
			you_are_currently_editing_changing_the_page_will_lose_your_changes:
				"You are currently editing. Changing the page will lose your changes. Are you sure you want to continue?",
			record_needs_saveable_page:
				"Fill in the page's required fields first — the recording is anchored in the saved page.",
			save_before_recording_failed: "The page could not be saved, so the recording was called off.",
			stop_recording: "Stop Recording",
			recording_in_progress: "Recording...",
		},
		statistics: {
			statistics: "Statistics",
		},
		protocols: {
			added_as_involved_title: "Added to a protocol",
			added_as_involved_message: '{name} added you as an involved party to the protocol "{title}".',
			protocol: "Protocol",
			protocols: "Protocols",
			title: "Title",
			meeting: "Meeting Protocol",
			negotiation: "Negotiation Protocol",
			call_note: "Call Note",
			call_request: "Call Request",
			general: "General Protocol",
			templates: "Templates",
			type: "Type",
			types: "Types",
			recipients: "Recipients",
			location: "Location",
			attendees: "Attendees",
			add_section: "Add Section",
			delete_section_confirm_message:
				"Are you sure you want to delete this section? This action cannot be undone.",
			section_title_placeholder: "Section Title (Optional)",
			protocol_subject: "Protocol Subject",
			select_subject: "Select Subject",
			protocol_subject_project: "Project",
			protocol_subject_offer: "Offer",
			protocol_subject_other: "Other",
			short_description: "Short Description",
			protocol_title: "Protocol Title",
			create_protocol: "Create Protocol",
			edit_protocol: "Edit Protocol",
			are_you_sure_you_want_to_dismiss_this_protocol:
				"Are you sure you want to dismiss this protocol? This action cannot be undone.",
			context: "Context",
			content: "Content",
			call_request_for_user: "Call Request for User",
			caller: "Caller",
			no_recipients: "No Recipients",
			callback_time: "Callback Time",
			send_notification: "Send Notification",
			add_users_or_contact_members: "Add Users or Contact Members...",
			involvements: "Involvements",
			count_involvements: "{count} Involvements",
			untitled: "Untitled",
			related_protocols: "Related Protocols",
			callback_log: "Callback Log",
			callback_resolved: "Called Back",
			callback_open: "Awaiting Callback",
			callback_attempt: "Failed Attempt",
			count_callback_attempts: "{count} failed attempts",
			mark_as_called_back: "Mark as Called Back",
			log_failed_attempt: "Log Failed Attempt",
			no_callback_events: "No callback logged yet",
			callback_note: "Note",
			callback_note_placeholder: "What happened on the call?",
			export_pdf: "Export as PDF",
			pdf_created: "PDF created and attached to the protocol",
			send_protocol: "Send Protocol",
			send_with_attachment: "Attach as PDF",
			send_copy_to_me: "Send me a copy",
			no_email_address: "No email address",
			sent_emails: "Sent Emails",
			no_sent_emails: "Nothing sent yet",
			protocol_sent: "Protocol sent to {count} recipients",
			protocol_sent_partial: "Protocol sent to {count} of {total} recipients",
			protocol_sent_to_nobody: "The protocol could not be sent to any recipient",
			protocol_not_loaded: "The protocol could not be loaded",
			not_found: "This protocol no longer exists.",
			project_not_found: "This project no longer exists.",
			colleague_not_found: "One of the colleagues named is not a member of this organisation.",
			contact_member_not_found: "One of the contact persons named no longer exists.",
			no_recipient_with_email: "Nobody involved in this protocol has an email address.",
		},
		priority: {
			priority: "Priority",
			low: "Low",
			medium: "Medium",
			high: "High",
			very_high: "Very High",
			custom: "Custom",
		},
		filter: {
			match_any_or: "Match any (OR)",
			match_all_and: "Match all (AND)",
		},
		webfleet: {
			integration_not_available:
				"Webfleet integration is not available. Please contact your administrator.",
			destination: "Destination",
			odometer: "Odometer",
			ordertext: "Order Text",
			tripmode: {
				tripmode: "Tripmode",
				private_trip: "Private Trip",
				business_trip: "Business Trip",
				unknown_trip_type: "Unknown Trip Type",
				commute_trip: "Commute Trip",
				correction_trip: "Correction Trip",
			},
			order_states: {
				order_state: "Order State",
				not_yet_sent: "Not yet sent",
				sent: "Sent",
				received: "Received",
				read: "Read",
				accepted: "Accepted",
				service_order_started: "Service order started",
				arrived_at_destination: "Arrived at destination",
				work_started: "Work started",
				work_finished: "Work finished",
				departed_from_destination: "Departed from destination",
				proof_of_delivery: "Proof of delivery",
				pickup_order_started: "Pickup order started",
				arrived_at_pickup_location: "Arrived at pick up location",
				pickup_started: "Pick up started",
				pickup_finished: "Pick up finished",
				departed_from_pickup_location: "Departed from pick up location",
				delivery_order_started: "Delivery order started",
				arrived_at_delivery_location: "Arrived at delivery location",
				delivery_started: "Delivery started",
				delivery_finished: "Delivery finished",
				departed_from_delivery_location: "Departed from delivery location",
				resumed: "Resumed",
				suspended: "Suspended",
				cancelled: "Cancelled",
				rejected: "Rejected",
				finished: "Finished",
			},
			vehicle_types: {
				ape: "Ape",
				barge: "Barge",
				bike: "Bike",
				boom_lift: "Boom Lift",
				boom_lift_truck: "Boom Lift Truck",
				bus: "Bus",
				caddy: "Small Van",
				car: "Car",
				car_station_wagon: "Car Station Wagon",
				concrete_lorry: "Concrete Lorry",
				containership: "Containership",
				crane: "Crane",
				deposit_tipper: "Deposit Tipper",
				dump_truck: "Dump Truck",
				dump_truck_open: "Dump Truck Open",
				excavator: "Excavator",
				garbage_truck: "Garbage Truck",
				heavy_truck: "Heavy Truck",
				heavytruck_us: "Heavy Truck US",
				heavyweight_truck: "Heavyweight Truck",
				heavyweight_truck_trailer: "Heavyweight Truck Trailer",
				lighttruck: "Light Truck",
				light_truck_pallet: "Light Truck Pallet",
				loader: "Loader",
				medium_truck: "Medium Truck",
				multicar: "Multicar",
				multivan: "Multivan",
				pallet_truck: "Pallet Truck",
				pickup: "Pickup",
				smart: "Smart",
				sprinter: "Sprinter",
				street_sweeper: "Street Sweeper",
				suv: "SUV",
				tanker_truck: "Tanker Truck",
				telescopic_handler: "Telescopic Handler",
				tractor: "Tractor",
				trailer: "Trailer",
				train: "Train",
				truck_loader_arm: "Truck Loader Arm",
				truck_trailer: "Truck Trailer",
				truck_with_trailer: "Truck with Trailer",
				truck_wrecker: "Truck Wrecker",
				van: "Van",
				vespa: "Vespa",
				wrecker: "Wrecker",
				yacht: "Yacht",
				ambulance: "Ambulance",
				firetruck: "Firetruck",
				police: "Police",
				taxi: "Taxi",
				taxi_uk: "Taxi UK",
			},
		},
		insights: {
			ask_ai: "Ask AI",
			ask_a_question: "Ask a question about your data",
			placeholder: "e.g. What is the average price for a protective scaffold?",
			searching: "Searching...",
			no_rows: "No matching records were found.",
			cant_answer: "This question could not be answered from the available data.",
			view_record: "View record",
			raw_data: "Raw data",
		},
		calculations: {
			expand_sidebar: "Expand sidebar",
			collapse_sidebar: "Collapse sidebar",
			convert_to_project: "Convert to project",
			calculation_was_alreay_converted: "Calculation was already converted",
			remove_assignment_from_calculation: "Remove Assignment from Calculation",
			remove_from_parent: "Remove from Parent",
			move_down: "Move Down",
			move_up: "Move Up",
			add_calculation: "Add Calculation",
			from_file: "From file",
			from_scratch: "From scratch",
			offer_upload_hint: "Drop a .pdf, .x83/.d83 (LV), or .x83/.d83 + .x84/.d84 together",
			offer_building: "Building your calculation, hold on...",
			offer_missing_x83: "Please also add the matching .x83/.d83 file alongside your .x84/.d84",
			importing_offer: "Reading the offer...",
			import_offer: "Create calculation",
			offer_imported: "The calculation has been created.",
			offer_import_failed: "No calculation could be created from this file.",
			eventual_position: "Eventualposition (E.P.)",
			add_to_calculation: "Add to Calculation",
			create_calculation: "Create Calculation",
			delete_calculation: "Delete Calculation",
			delete_calculation_confirm_message:
				"Are you sure you want to delete this calculation? This action cannot be undone. All associated data will also be deleted. This also affects all references to this calculation on other instances.",
			edit_calculation: "Edit Calculation",
			calculation: "Calculation",
			calculations: "Calculations",
			pending: "Pending",
			locked: "Locked",
			result: "Result",
			created_calculation: "Created Calculation",
			add_service_to_calculation: "Add Service to Calculation",
			add_services_to_start_calculation: "Add services to start calculation",
			find_a_name_to_identify_your_calculation_later:
				"Find a name to identify your calculation later",
			quantity: "Quantity",
			length: "Length",
			width: "Width",
			width_short: "W",
			height: "Height",
			height_short: "H",
			depth: "Depth",
			depth_short: "D",
			meters: "Meters",
			weight: "Weight",
			adjusted_unit_price_to_min: "Adjusted unit price to minimum ({minPrice})",
			adjusted_unit_price_to_max: "Adjusted unit price to maximum ({maxPrice})",
			preparing_calculation: "Preparing calculation...",
			calculation_not_loadable: "This calculation could not be loaded.",
			initializing_calculation: "Initializing calculation...",
			member_source_offer_match: "Offer Match",
			member_source_manual: "Manual",
			add_member: "Add Member",
			delete_calculation_member_confirm_message:
				"Are you sure you want to remove this member from the calculation?",
			meta_data: "Meta Data",
			offer_number: "Offer Number",
			project_name: "Project Name",
			block: "Block",
			add_block: "Add Block",
			block_quantity: "Quantity (multiplier)",
			add_position: "Add Position",
			position_name: "Position Name",
			add_service_to_block: "Add Service",
			manual_measurement: "Manual Result",
			use_manual_measurement: "Enter result directly",
			use_dimensions: "Calculate from dimensions",
			not_found: "This calculation no longer exists.",
			calculation_locked: "This calculation is locked and can no longer be edited.",
			reference_not_found: "This calculation is no longer linked to that entry.",
			item_not_found: "One of the services belongs to another calculation.",
			position_not_found: "One of the positions belongs to another service.",
			reference_approved:
				"This entry is already approved. A calculation can no longer be linked to it.",
			calculation_reported:
				"This calculation has gone out in a partner report and can no longer be unlocked.",
			lock: "Lock",
			unlock: "Unlock",
			lock_successful: "Calculation locked",
			unlock_successful: "Calculation unlocked",
			unlock_confirm_title: "Unlock calculation?",
			unlock_confirm_message:
				"The calculation can be edited again. If it was locked by an approval, it stays unlocked until the approval is withdrawn and given again.",
			locked_banner: "Locked by {name} on {date}. The calculation can no longer be edited.",
			locked_by_approval_banner:
				"Locked by {name}'s approval on {date}. The calculation can no longer be edited.",
		},
		permissions: {
			permissions: "Permissions",
			permission: "Permission",
			granted_by_role: "Granted by role",
			successfully_updated: "Permissions successfully updated",
			failed_to_update: "Failed to update permissions",
			owner_role_note: "Owners have full access. Their role cannot be changed.",
			owner_permissions_note: "Owners have full access. Their permissions cannot be edited.",
			wildcard_permissions_note:
				"Full access through {roles}. Individual permissions cannot be edited while the role is active.",
			covered_by_role: "Included in a role",
			covered_by_roles: "Included in: {roles}",
			from_roles: "from {roles}",
			individually_extended: "Individually extended",
			subjects: {
				stock: "Warehouse",
				contact: "Contacts",
				contact_members: "Contact persons",
				contact_projects: "Client projects",
				contact_services: "Client services",
				employment: "Employment data",
				vehicle: "Vehicles",
				service: "Services",
				partner: "Partners",
				team: "Teams",
				permission: "Permissions",
				absence: "Absences",
				attendance: "Time tracking",
				user: "Employees",
				invoice: "Invoices",
				incoming_invoice: "Incoming invoices",
				ticket: "Tickets",
				measurement: "Measurements",
				calculation: "Calculations",
				project: "Projects",
				plan: "Planning board",
				organization: "Organisation",
				file: "Files",
				note: "Notes",
				integration: "Integrations",
			},
			actions: {
				read: "View",
				create: "Create",
				update: "Edit",
				delete: "Delete",
				approve: "Approve",
				manage: "Manage",
			},
			you_are_not_authorized_to_access_this_page: "You are not authorized to access this page.",
			projects: {
				description:
					"All permissions that are related to projects and tickets in general. Not including invoices or documents.",
				can_insert_label: "Can insert",
				can_insert_description: "Can insert projects.",
				can_insert_tickets_unaffiliated_label: "Can insert tickets",
				can_insert_tickets_unaffiliated_description:
					"Can insert tickets where the user is not a manager or deputy.",
				can_delete_unaffiliated_label: "Can delete",
				can_delete_unaffiliated_description:
					"Can delete projects and tickets where the user is not a manager or deputy.",
				can_update_unaffiliated_label: "Can update",
				can_update_unaffiliated_description:
					"Can update projects and tickets where the user is not a manager or deputy.",
				can_read_unaffiliated_label: "Can read",
				can_read_unaffiliated_description:
					"Can read unaffiliated projects and tickets where the user is not a manager or deputy.",
			},
			invoices: {
				description: "All permissions that are related to invoices.",
				can_insert_label: "Can insert",
				can_insert_description: "Can insert invoices.",
				can_delete_label: "Can delete",
				can_delete_description: "Can delete invoices.",
				can_update_label: "Can update",
				can_update_description: "Can update invoices.",
				can_read_label: "Can read",
				can_read_description: "Can read invoices.",
			},
			contacts: {
				description: "All permissions that are related to contacts.",
				can_insert_label: "Can insert",
				can_insert_description: "Can insert contacts.",
				can_delete_label: "Can delete",
				can_delete_description: "Can delete contacts.",
				can_update_label: "Can update",
				can_update_description: "Can update contacts.",
				can_read_label: "Can read",
				can_read_description: "Can read contacts.",
			},
			partners: {
				description: "All permissions that are related to partners.",
				can_send_report_label: "Can send report",
				can_send_report_description: "Can send partner timeline reports.",
			},
			not_grantable: "The permission {key} cannot be granted.",
		},
		notifications: {
			kinds: {
				note_mention: "Mentioned in a note",
				note_mention_description: "When someone mentions you in a note.",
				protocol_involvement: "Added to a protocol",
				protocol_involvement_description:
					"When someone adds you as an involved party to a protocol.",
				project_assigned: "Assigned as site manager",
				project_assigned_description: "When someone makes you the site manager of a project.",
				project_number_changed: "Project number changed",
				project_number_changed_description: "When the number of a project you manage changes.",
				order_complete: "Order picked",
				order_complete_description:
					"When an order for a project you manage has been picked in the warehouse.",
				plan_published: "Plan published",
				plan_published_description: "When a plan you are on is published or changed.",
				attendance_decided: "Attendance approved or rejected",
				attendance_decided_description: "When one of your attendances is approved or rejected.",
				substitution_assigned: "Assigned as substitute",
				substitution_assigned_description:
					"When you take over the projects of a colleague who is away.",
				substitution_team_note: "Substitution list for your team",
				substitution_team_note_description:
					"When a substitution list is submitted for a colleague on your team.",
				substitution_external_note: "Change of contact person",
				substitution_external_note_description:
					"When your contact person on a project is away and someone else stands in.",
				partner_report: "Partner report",
				partner_report_description:
					"A collection of PDFs containing calculations for external services.",
				partnership_requested: "Partnership requested",
				partnership_requested_description:
					"When a company redeems your partnership code and waits for your activation.",
				partnership_activated: "Partnership activated",
				partnership_activated_description:
					"When a client activates the partnership and can book your crews from then on.",
				partnership_deactivated: "Partnership deactivated",
				partnership_deactivated_description:
					"When a client deactivates the partnership, so no further bookings are possible.",
				incoming_invoice_review_requested: "Invoice to review",
				incoming_invoice_review_requested_description:
					"When an incoming invoice awaits your review: it arrived, it was handed to you, or the approval chain reached you.",
				incoming_invoice_review_decided: "Handed-over invoice decided",
				incoming_invoice_review_decided_description:
					"When someone you handed an incoming invoice to rejects it, or approves it without it coming back to you — when it does come back, the review request tells you.",
			},
			groups: {
				notes: "Notes",
				protocols: "Protocols",
				projects: "Projects",
				orders: "Orders",
				planning: "Planning",
				attendances: "Attendances",
				substitutions: "Substitutions",
				partners: "Partners",
				incoming_invoices: "Incoming invoices",
			},
			preferences: {
				title: "Notifications",
				description: "Choose which notifications reach you, by push and by e-mail.",
				push: "Push",
				email: "E-mail",
				no_email_hint: "Your account has no e-mail address, so you receive pushes only.",
				not_available: "Not available",
				not_available_push: "This notification is not sent as a push.",
				not_available_email: "This notification is not sent as an e-mail.",
				saved: "Preferences saved",
				channel_on: "On",
				channel_off: "Off",
			},
			channels_not_offered: "These notification channels are not available: {names}.",
		},
		emails: {
			preferences: {
				title: "E-mail preferences",
				intro: "Choose which e-mails {email} receives.",
				receive: "Receive",
				save: "Save",
				saved_title: "Preferences saved",
				saved_body: "Your choice applies to every e-mail sent to {email} from now on.",
				all_off: "Receive none of these e-mails",
			},
			types: {
				partner_report: "Partner Report",
				partner_report_description:
					"A collection of PDFs containing calculations for external services.",
				note_mention: "Mention in a note",
				note_mention_description: "Sent when someone mentions you in a note.",
				protocol_involvement: "Added as involved party",
				protocol_involvement_description:
					"Sent when someone adds you as an involved party to a protocol.",
				order_complete: "Order picked",
				order_complete_description:
					"Sent when an order for a project you manage has been picked in the warehouse.",
				project_assigned: "Assigned as site manager",
				project_assigned_description: "Sent when someone makes you the site manager of a project.",
				project_number_changed: "Project number changed",
				project_number_changed_description: "Sent when the number of a project you manage changes.",
			},
			states: {
				bounced: "Bounced",
				canceled: "Canceled",
				clicked: "Clicked",
				complained: "Complained",
				delivered: "Delivered",
				delivery_delayed: "Delivery Delayed",
				failed: "Failed",
				opened: "Opened",
				queued: "Queued",
				scheduled: "Scheduled",
				sent: "Sent",
			},
			greeting: {
				hello: "Hello",
				mr: "Dear Mr.",
				mrs: "Dear Ms.",
			},
			unsubscribe: {
				hint: "If you no longer wish to receive these emails, please click on the following link to manage your e-mail preferences.",
				manage: "Manage e-mail preferences",
			},
			note_mention: {
				subject: '{author} mentioned you in a note – {kind} "{label}"',
				body: "{author} mentioned you in a note.",
				parent: '{kind} "{label}"',
				note: "Note",
				open: "Open",
			},
			protocol_involvement: {
				subject: "{type}: {title}",
				body: "{name} added you as an involved party to the following protocol:",
				protocol: '{type} "{title}"',
				on_date: '{type} "{title}" dated {date}',
				external_hint: "The protocol will be sent to you by e-mail once it is sent out.",
				open: "Open protocol",
			},
			order_complete: {
				subject: "Order {number} for {project} picked",
				body: "{name} has finished picking order {number} for {project}. The goods are ready for transport.",
				delivery_date: "Delivery date",
				open: "Open order",
			},
			project_assigned: {
				subject: "You are now site manager of {number} {project}",
				body: "{name} has assigned you as site manager of project {number} {project}.",
				address: "Address",
				open: "Open project",
			},
			project_number_changed: {
				subject: "New project number {number} for {project}",
				body: "{name} has changed the project number of {project}, which you manage as site manager.",
				previous_number: "Previous number",
				new_number: "New number",
				none: "none",
				open: "Open project",
			},
			partnership_requested: {
				subject: "{name} redeemed your partnership code",
				title: "Partnership requested",
				body: "{name} has redeemed your partnership code and is waiting for you to activate the partnership. Once it is active, you can schedule their crews.",
				open: "Open partner",
			},
			partnership_activated: {
				subject: "{name} activated your partnership",
				title: "Partnership activated",
				body: "{name} has activated the partnership and can schedule your crews from now on.",
				open: "Open partner",
			},
			partnership_deactivated: {
				subject: "{name} deactivated your partnership",
				title: "Partnership deactivated",
				body: "{name} has deactivated the partnership. No further bookings are possible until it is activated again.",
				open: "Open partner",
			},
			incoming_invoice_review_requested: {
				subject: "To review: {invoice}",
				body_received: "{invoice} has arrived and awaits your review.",
				body_handed_over: "{name} has handed you {invoice} to review.",
				body_turn: "{invoice} is now with you to review.",
				body_returned: "{name} approved {invoice}. It is back with you to review.",
				number: "Invoice number",
				issuer: "Issued by",
				amount: "Gross amount",
				due_date: "Due date",
				workspace: "Workspace",
				handed_over_by: "Handed over by",
				accepted_by: "Accepted by",
				comment: "Comment",
				open: "Open invoice",
			},
			incoming_invoice_review_decided: {
				subject_approved: "{name} approved {invoice}",
				subject_rejected: "{name} rejected {invoice}",
				body_approved: "{name} approved {invoice}. You had handed the invoice over for review.",
				body_rejected: "{name} rejected {invoice}. You had handed the invoice over for review.",
				decision: "Decision",
				approved: "Approved",
				rejected: "Rejected",
				comment: "Comment",
				reason: "Reason",
				number: "Invoice number",
				issuer: "Issued by",
				amount: "Gross amount",
				due_date: "Due date",
				workspace: "Workspace",
				open: "Open invoice",
			},
			substitution_internal_note: {
				subject: "Project substitution - {name}",
				body: "Because {name} is absent during {span}, the following projects have been assigned to you as a substitute:",
				projects: "Projects",
				note: "Note",
				open: "Open",
			},
		},
		measurements: {
			show_closed_statements: "Show Closed Statements",
			show_open_statements: "Show Open Statements",
			open_measurement_list: "Open Measurement List",
			measurements: "Measurements",
			statement: "Statement",
			ticket_assignments_total: "Ticket Assignments (Total)",
			ticket_assignment_measurement_statements_total:
				"Ticket Assignment Measurement Statements (Total)",
			ticket_assignment_measurement_statements_open_total:
				"Ticket Assignment Measurement Statements (Open)",
			answered_by: "Answered By",
			answered_at: "Answered At",
			closed_by: "Closed By",
			closed_at: "Closed At",
			is_closed: "Is Closed",
			is_open: "Is Open",
			marked_as_closed: "Marked as closed",
			marked_as_open: "Marked as open",
			mark_selected_as_closed: "Mark selected as closed",
			mark_selected_as_open: "Mark selected as open",
			assignment_not_found: "This ticket assignment is not part of this project.",
			options: {
				remember: "Remember",
				without_charge: "Without Charge",
				included: "Included",
			},
		},
		cost_centers: {
			add_cost_center: "Add Cost Center",
			cost_center: "Cost Center",
			cost_centers: "Cost Centers",
			deactivated_instead: "The cost center is booked to, so it was deactivated instead",
			delete_cost_center_confirm_message:
				"Delete this cost center? If invoices are booked to it, it is deactivated instead.",
			edit_cost_center: "Edit Cost Center",
			is_active: "Active",
			name: "Name",
			name_placeholder: "e.g. Scaffolding North",
			number: "Number",
			number_placeholder: "e.g. 4100",
			select_cost_center: "Select a cost center",
		},
		dashboard: {
			hello: "Hello {name}.",
			dashboard: "Dashboard",
			"7_days_forecast": "7-Days Forecast",
			tickets_total_count: "Total",
			user_tickets_count: "Own",
			today: "Today",
			my_projects: "My Projects",
			measurements: "Measurements",
			absences: "Absences",
			weather: "Weather",
			my_tasks: "My Tasks",
			invoice_approvals: "Invoice Approvals",
			n_open_invoice_approvals: "{count} open",
			partner_booking_reviews: "Review bookings",
			n_partner_booking_reviews: "{count} to review",
			partner_bookings_due: "Submit bookings",
			n_partner_bookings_due: "{count} open",
			notes: "Notes",
			open_projects: "Open Projects",
			ticket_assignments: "Ticket Assignments",
			missing_statements: "Missing Statements",
			yearly_statistics: "Yearly Statistics",
			invoice_total: "Invoice Total",
			invoices_paid: "Invoices Paid",
			own_crews: "Own Crews",
			partner_crews: "Partner Crews",
			protocols: "Protocols",
			alerts: {
				level_types: {
					info: "Info",
					danger: "Danger",
					success: "Success",
					warning: "Warning",
					neutral: "Neutral",
				},
				delete_confirmation_message:
					"Are you sure you want to delete this alert? This action cannot be undone.",
				alerts: "Alerts",
				alert: "Alert",
				alert_level: "Level",
				add_alert: "Add alert",
				edit_alert: "Edit alert",
				missing_substitution_plan_title: "Action Required: Substitution Plan",
				missing_substitution_plan_description:
					"Please provide a substitution plan for the period between {startDate} and {endDate}.",
				user_can_dismiss_alert: "User can dismiss alert",
				teams: "Teams",
			},
		},
		native: {
			grant_permission: "Grant permission",
			grant_permission_camera: "We need your permission to show the camera",
		},
		video_recorder: {
			click_to_capture_video: "Click here to capture a video",
			capture_video: "Capture a video",
			recovery_title: "Send the unfinished recording?",
			recovery_message:
				'{duration} of "{label}" survived the interruption. Send it now, or delete it — nothing else on the page changes either way.',
			recovery_lost_title: "This recording can no longer be sent",
			recovery_lost_message:
				'{duration} of "{label}" is still here, but its destination is gone — the page no longer holds a place for it, so there is nowhere to send it.',
			recovery_send: "Send now",
			recovery_busy: "Finish the recording in progress first, then send this one.",
			recovery_delete: "Delete recording",
			remaining: "{time} left",
			stopped_at_limit:
				"The recording reached the {minutes}-minute limit and stopped. What was recorded is kept.",
			screen_with_voice: "Screen + voice",
			screen_with_camera: "Screen + camera + voice",
			screen_silent: "Screen only",
			camera_with_voice: "Camera + voice",
			start_recording: "Start recording",
			start_failed: "The recording could not be started. Please try again.",
			stop_recording: "Stop recording",
			pause_recording: "Pause",
			resume_recording: "Resume",
			assembling_recording: "Finishing the recording…",
			recording_short: "Recording",
			paused_short: "Paused",
			undock: "Keep visible outside the browser",
			can_trim_later: "You can trim this video later on the page.",
			retry_upload: "Try again",
			open_target: "Go to page",
			discard_recording: "Discard",
			recording: "Recording…",
			paused: "Paused — your screen is still shared",
			camera_unavailable:
				'No access to the camera or microphone. Allow both in your browser, or choose "Screen only".',
			microphone_unavailable:
				'No access to the microphone. Allow it in your browser, or choose "Screen only".',
		},
		videos: {
			already_rendering: "This video is being recalculated right now.",
			cut_discard_original: "Delete the original",
			cut_end_handle: "End of the part to keep",
			cut_failed_selection_kept: "The cut failed. Your selection is saved.",
			cut_here: "Cut here",
			cut_keep_original: "Keep the original",
			cut_out_of_range: "That cut does not fit inside this video.",
			cut_overlapping: "The parts to keep must run in order and must not overlap.",
			cut_rendering: "Applying your cut…",
			cut_restore: "Put this part back",
			cut_retry: "Try the cut again",
			cut_start_handle: "Start of the part to keep",
			cut_too_short: "A cut has to keep at least half a second of video.",
			cut_video: "Cut video",
			insert_image_failed: "The image could not be inserted.",
			insert_video: "Insert video",
			insert_video_failed: "The video could not be inserted.",
			not_found: "This video no longer exists.",
			not_ready: "This video is not ready yet.",
			not_uploadable: "This recording can no longer be uploaded.",
			only_images_and_videos: "Only image and video files are supported.",
			processing: "Processing…",
			processing_failed: "Processing this video failed.",
			re_record: "Record again",
			recording_in_progress: "Recording in progress…",
			title: "Title",
			upload_failed: "The upload failed.",
			upload_media: "Upload image/video",
			upload_media_hint: "Choose an image or video file, or drop it here",
			uploading: "Uploading…",
			video: "Video",
		},
		stock: {
			my_orders: "My Orders",
			stock: "Stock",
			catalogue: "Catalogue",
			ordering: "Ordering",
			logistics: "Logistics",
			articles: "Articles",
			article: "Article",
			add_article: "Add Article",
			add_articles: "Add Articles",
			vendor: "Vendor",
			vendors: "Vendors",
			vendor_article_number: "Vendor Article Number",
			add_vendor_article: "Add Vendor Article",
			edit_vendor_article: "Edit Vendor Article",
			edit_article: "Edit Article",
			article_groups: "Article Groups",
			article_group: "Article Group",
			article_group_number: "Article Group Number",
			add_article_group: "Add Article Group",
			edit_article_group: "Edit Article Group",
			select_article_group: "Select Article Group",
			article_product_type: "Article Product Type",
			article_product_types: "Article Product Types",
			article_product_type_number: "Article Product Type Number",
			select_product_type: "Select Product Type",
			add_article_product_type: "Add Article Product Type",
			edit_article_product_type: "Edit Article Product Type",
			article_group_has_no_product_types: "Article Group has no Product Types",
			article_no: "Article-No.",
			order_no: "Number",
			auto_generate_number: "Auto Generate Number",
			number_is_already_taken:
				"This number is already taken. Do you want to use the available {number} instead?",
			create_order_template: "Create Order Template",
			order_templates: "Order Templates",
			edit_order_template: "Edit Order Template",
			delete_order_template: "Delete Order Template",
			number_of_articles: "Number of Articles",
			count_articles: "{count} articles",
			delete_order_template_confirmation:
				"Are you sure you want to delete this order template? This action cannot be undone.",
			add_order: "Add Order",
			edit_order: "Edit Order",
			cancel_order: "Cancel Order",
			orders: "Orders",
			order_id: "Order-ID",
			suborders: "Suborders",
			n_suborders: "{count} Suborders",
			suborder_id: "Suborder-ID",
			select_articles: "Select articles",
			insert_template_articles: "Insert template articles",
			successfully_inserted_template_articles: "Successfully inserted template articles",
			inserting_template_articles_failed: "Inserting template articles failed",
			delivery: "Delivery",
			delivery_date: "Delivery date",
			delivery_window: "Delivery window",
			tours: "Tours",
			tour: "Tour",
			tour_wave: "Tour Wave",
			tour_waves: "Tour Waves",
			add_tour_wave: "Add Tour Wave",
			edit_tour_wave: "Edit Tour Wave",
			purchase_price: "Purchase Price",
			cutoff_offset: "Cutoff Offset",
			deadline: "Deadline",
			delete_tour_wave_confirmation:
				"Are you sure you want to delete this tour wave? This action cannot be undone.",
			delete_order_confirmation:
				"Are you sure you want to delete this order? This action cannot be undone.",
			delete_suborder_confirmation:
				"Are you sure you want to delete this suborder? This action cannot be undone.",
			cutoff_time_helper_text:
				"An order for this tour on a {weekday} would have to be placed before {cutoffDate}.",
			these_article_numbers_couldnt_be_resolved:
				"The following article numbers couldn't be resovled. Please inform your admin to add the missing items to the database.",
			warehouse_zones: "Warehouse Zones",
			all_warehouse_zones: "All zones",
			start_picking: "Start picking",
			already_picked_of_required: "{picked} of {required} already picked",
			picking: "Picking",
			warehouse_zone: "Warehouse Zone",
			warehouse_locations: "Warehouse Locations",
			warehouse_location: "Warehouse Location",
			available_quantity: "Available here",
			required: "Required",
			picked: "Picked",
			ordered: "Ordered",
			booked_out: "Booked out",
			booked_at: "Booked out at",
			planned: "Planned",
			over_picked_by: "{overage} more picked than the order needs.",
			open_in_other_zones: "{quantity} more is being picked in another warehouse area.",
			still_needed: "Still needed",
			article_has_no_image: "No image",
			shipping_labels: "Shipping Labels",
			no_shipping_labels:
				"No shipping labels yet — they are created when a picking round is finished.",
			add_warehouse_zone: "Add Warehouse Zone",
			edit_warehouse_zone: "Edit Warehouse Zone",
			delete_warehouse_zone: "Delete Warehouse Zone",
			has_location: "Has Location",
			warehouse_zone_shelf_size: "Shelf Size",
			warehouse_zone_axis_size: "Axis Size",
			warehouse_zone_floor_size: "Floor Size",
			warehouse_zone_label: "Label",
			warehouse_zone_label_failed: "This label could not be rendered.",
			unknown_warehouse_zone: "That code is not a warehouse area of your warehouse.",
			warehouse_zone_number: "Zone Number",
			warehouse_shelf: "Shelf",
			warehouse_axis: "Axis",
			warehouse_floor: "Floor",
			warehouse_zone_type: {
				warehouse_zone_type: "Warehouse Zone Type",
				consolidation: "Consolidation",
				receiving: "Receiving",
				shipping: "Shipping",
				staging: "Staging",
				storage: "Storage",
			},
			select_warehouse_locations: "Select Warehouse Locations",
			order_state: {
				order_state: "Order State",
				pending: "Pending",
				open: "Open",
				in_progress: "In Progress",
				completed: "Completed",
				picking: "Picking",
				canceled: "Canceled",
			},
			release_order: "Release order",
			recall_order: "Recall order",
			restore_order: "Restore order",
			restoring_order: "Restoring order...",
			restoring_order_failed: "Restoring order failed...",
			restoring_order_successful: "Restoring order successful...",
			cancelling_order: "Cancelling order...",
			cancelling_order_failed: "Cancelling order failed...",
			cancelling_order_successful: "Cancelling order successful...",
			cancel_order_confirmation_message:
				"Are you sure you want to cancel this order and all of its suborders? This action can be undone by an adminstrator.",
			restore_order_confirmation_message:
				"Are you sure you want to restore this order? It and all of its suborders return to pending.",
			book_pick: "Book pick",
			scanned_shelf_not_listed: "That shelf is not one this article is stocked at.",
			finish_picking: "Finish picking",
			picked_quantity_over_open_quantity: "{overage} more than this line needs will be booked.",
			picked_from_here: "{quantity} picked from this shelf.",
			picking_summary: "Summary",
			picking_signoff: "Sign-off",
			picking_signoff_locked:
				"The sign-off opens once every line is picked and every ordered carrier is covered.",
			picking_signoff_hint:
				"Check the round over before you hand it on. Finishing books the carriers out of the yard.",
			signoff_article_lines: "Article lines",
			signoff_no_carriers: "Nothing going along.",
			picking_summary_locked: "The summary opens once every line is picked.",
			picked_of_required: "{picked} of {required} picked",
			still_needed_quantity: "{quantity} still needed",
			picked_quantity: "Picked quantity",
			open_quantity: "Open quantity",
			stock_balance: "Stock balance",
			quantity_on_location: "On this location",
			articles_on_location: "Articles",
			location_stock_balance: "On location",
			reserved_quantity: "Reserved",
			orderable_quantity: "Available to order",
			warning_stock_balance: "Warning stock balance",
			minimum_stock_balance: "Minimum stock balance",
			requires_transfer_carrier_on_return: "Requires transfer carrier on return",
			article_has_no_warehouse_location:
				"This article has no warehouse location yet. Assign one before booking it back in.",
			no_receiving_zone:
				"No goods-in zone is configured. Create a warehouse zone of type “Receiving” first.",
			transfer_carrier_required: "This article has to be returned on a transfer carrier.",
			transfer_carrier: "Transfer carrier",
			transfer_carriers: "Transfer carriers",
			scan_transfer_carrier: "Scan transfer carrier",
			scan_transfer_carrier_description:
				"Scan the number on the trolley the material was loaded onto.",
			unknown_transfer_carrier: "This transfer carrier does not belong to your warehouse.",
			transfer_carrier_in_use:
				"This transfer carrier still has material on it. Put it away before deleting the carrier.",
			add_transfer_carrier: "Add transfer carrier",
			edit_transfer_carrier: "Edit transfer carrier",
			delete_transfer_carrier: "Delete transfer carrier",
			delete_transfer_carrier_confirmation:
				"Are you sure you want to delete this transfer carrier? This action cannot be undone.",
			transfer_carrier_no: "Carrier-No.",
			transfer_carrier_not_loaded: "This transfer carrier could not be loaded.",
			transfer_carriers_empty: "No transfer carrier has been added yet.",
			transfer_carrier_current_zone: "Currently in",
			transfer_carrier_number_hint: "Leave empty to use the next free number.",
			transfer_carrier_open_legs: "On it",
			transfer_carrier_history: "Put-aways",
			transfer_carrier_history_empty: "This transfer carrier has not carried anything yet.",
			transfer_carrier_label: "Label",
			transfer_carrier_label_hint:
				"Print this and stick it on the trolley. The code is scanned to load and unload it.",
			transfer_carrier_label_failed: "This label could not be rendered.",
			download_transfer_carrier_label: "Download label",
			scan_transfer_carrier_button: "Scan trolley",
			transfer_carrier_scanned: "Trolley {name}",
			transfer_carrier_spans_return_orders:
				"This trolley carries loads from more than one return run.",
			scanned_code_unknown: "That code is neither a return run nor a trolley of your warehouse.",
			put_away_to_shelf: "To shelf {location}",
			put_away_raised: "Put-away raised",
			put_away_complete: "Put on shelf",
			put_away_nothing_open: "Nothing on this trolley.",
			put_away_carried_by_hand: "Carried by hand",
			put_away: "Put-away",
			put_aways: "Put-aways",
			put_away_open: "To be put away",
			put_away_destination: "To shelf",
			put_away_claim_trolley: "Take this trolley",
			put_away_progress: "{done} / {total} put away",
			put_away_spans_return_orders: "Loads from {count} return runs",
			scan_warehouse_location_description:
				"Scan the label on the shelf you are putting the material on.",
			scan_warehouse_location_button: "Scan shelf",
			warehouse_location_scanned: "Shelf {name}",
			shelf_not_assigned_to_article:
				"This article is not stocked on the shelf you scanned. Assign the location first.",
			article_quantity_state: {
				article_quantity_state: "Stock Level",
				ok: "OK",
				low: "Low",
				critical: "Critical",
				empty: "Empty",
			},
			transactions: "Transactions",
			transaction: "Transaction",
			operations: {
				operations: "Operations",
				operation: "Operation",
				add: "Add",
				remove: "Remove",
			},
			transaction_types: {
				transaction_type: "Transaction Type",
				correction: "Correction",
				pick: "Pick",
				inventory: "Inventory",
				restock: "Restock",
				return: "Return",
			},
			article_size: "Article Size",
			leergut: "Empties",
			ordered_load_carriers_not_picked:
				"The order still needs empty load carriers. Pick at least the ordered quantity before finishing the round.",
			load_carriers_ordered_minimum: "At least {quantity} ordered",
			no_warehouse_zone: "No zone",
			load_carriers: "Load Carriers",
			load_carrier: "Load Carrier",
			load_carrier_size: "Carrier Size",
			add_load_carrier: "Add Load Carrier",
			edit_load_carrier: "Edit Load Carrier",
			carriers_step_hint:
				"Tap a carrier to say how many go along. Nothing leaves the yard until the round is finished.",
			carriers_in_the_yard: "{quantity} in the yard",
			summary_continue: "Continue to load carriers",
			carriers_continue: "Continue to sign-off",
			carriers_going_along_title: "Carriers going along",
			delete_load_carrier: "Delete Load Carrier",
			delete_load_carrier_confirmation:
				"Delete this load carrier? Its whole movement ledger goes with it — every arrival, return and correction that explained its balance.",
			book_load_carrier_movement: "Book movement",
			quantity_is_over_orderable_quantity: "Only {available} available to order.",
			insufficient_available_stock:
				"Not enough stock available to order. Another order has already reserved it — reload and check the quantities.",
			order_not_cancellable:
				"This order is already being picked and can no longer be cancelled. Only an order that has not been released to the warehouse can be.",
			order_not_restorable: "Only a cancelled order can be restored.",
			non_storage_warehouse_zone:
				"Articles can only be stocked in a storage zone. Move the location into a storage zone first, or pick a different one.",
			order: "Order",
			suborder: "Suborder",
			follow_up_zone: "Follow-up zone",
			follow_up_zone_description:
				"Where a load carrier goes once it leaves this zone. Leave empty where the chain ends — a shipping zone usually does.",
			follow_up_zone_cycle:
				"This follow-up zone leads back to this zone, so load carriers would go round in a loop. Pick a different one, or change that zone's follow-up first.",
			home_zone: "Home zone",
			home_zone_description:
				"Where these carriers stand when empty. An order of empties alone has no picking zone, so this is what gives its transport somewhere to start.",
			transport_orders: "Transport Orders",
			transport_order: "Transport Order",
			transport_order_state: {
				pending: "To fetch",
				"in-transit": "In transit",
				complete: "Delivered",
				canceled: "Cancelled",
			},
			transport_mine: "Mine",
			transport_taken_over: "Taken over",
			transport_taken_over_message:
				"{carrier} was already on its way with somebody else. It is yours now — take it to {zone}.",
			transport_scan_title: "Scan a label",
			transport_scan_hint:
				"Scan a shipping label to take the carrier on. Scan it again once it is down at the next stop.",
			transport_picked_up: "Picked up",
			transport_delivered: "Delivered",
			transport_picked_up_message: "Carry {carrier} to {zone}.",
			transport_delivered_message: "{carrier} is at {zone}.",
			transport_next_stop: "Next stop: {zone}",
			transport_chain_ended: "This carrier has arrived. Nothing more to do.",
			transport_carrier: "Carrier",
			transport_from_zone: "From",
			transport_order_no: "Transport no.",
			transport_scan_zone: "Where are you?",
			transport_scan_zone_description:
				"Scan the label of {zone} to confirm you are standing there.",
			transport_scan_zone_confirm: "Confirm",
			scan_warehouse_zone_button: "Scan warehouse area",
			warehouse_zone_scanned: "Area {name}",
			wrong_warehouse_zone: "That is not where this load carrier can be moved.",
			wrong_warehouse_zone_title: "Wrong area",
			wrong_warehouse_zone_go_to: "Scan {carrier} in {zone}.",
			wrong_warehouse_zone_retry: "Scan again",
			transport_to_zone: "To",
			transport_picked_up_by: "Picked up by",
			transport_delivered_by: "Delivered by",
			transport_open_legs: "{count} open",
			no_transport_orders: "No transport orders",
			no_transport_orders_hint:
				"Carriers appear here once a picking round is signed off in a zone that names a follow-up.",
			cancel_transport_order: "Cancel transport order",
			cancel_transport_order_confirm_message:
				"Cancel this transport order? The carrier stays where it is and no follow-up is raised.",
			unknown_shipping_label:
				"This label does not belong to your warehouse. Check that it is one of yours.",
			transport_order_already_closed:
				"This carrier has already arrived — there is nothing left to carry.",
			order_not_loaded: "This order could not be loaded.",
			suborder_not_loaded: "This suborder could not be loaded.",
			order_completed: "Order completed",
			name_has_completed_order_for_project: "{name} has picked order {number} for {project}",
			protocol: "Protocol",
			protocol_created: "Raised",
			protocol_level_order: "Order",
			protocol_level_round: "Round {number}",
			protocol_unattributed: "Unknown",
			protocol_from_state: "From",
			protocol_to_state: "To",
			filter_state: "State",
			filter_state_all: "All states",
			filter_reset: "Reset filter",
			transport_event: {
				raised: "Raised",
				picked_up: "Picked up",
				taken_over: "Taken over",
				delivered: "Delivered",
				canceled: "Cancelled",
			},
			transport_events: "Chain of custody",
			transport_event_history: "Chain of custody",
			transport_taken_over_from: "Taken over from {name}",
			returns: "Return orders",
			return_order: "Return order",
			return_orders: "Return orders",
			return_order_no: "Return order no.",
			add_return_order: "New return order",
			add_return_order_description:
				"Raise a return order for a site being cleared. A sheet is printed for the truck.",
			return_order_not_loaded: "This return order could not be loaded.",
			return_orders_empty: "No return orders have been raised yet.",
			return_order_state: {
				open: "Open",
				"in-progress": "In progress",
				complete: "Completed",
				canceled: "Cancelled",
			},
			return_vehicles: "Vehicles",
			return_vehicles_none: "Not yet assigned",
			return_add_vehicle: "Add vehicle",
			return_remove_vehicle: "Remove vehicle",
			return_edit_vehicles: "Edit vehicles",
			return_reconciliation: "Reconciliation",
			return_shipped: "Shipped",
			return_returned: "Returned",
			return_received: "At goods-in",
			return_outstanding: "Still on site",
			return_last_picked_from: "Picked from",
			return_book: "Book return",
			return_book_quantity: "Quantity returned",
			return_book_location: "Return to",
			return_booked: "Booked",
			return_complete_order: "Complete return order",
			return_complete_order_confirm_message:
				"Complete this return order? Nothing further can be booked onto it afterwards.",
			return_cancel_order: "Cancel return order",
			return_cancel_order_confirm_message:
				"Cancel this return order? Anything already booked stays on the shelf — the stock is in the building.",
			return_print_sheet: "Print sheet again",
			return_scan_sheet: "Scan return sheet",
			return_scan_sheet_description: "Scan the QR code on the sheet from the truck.",
			return_unknown_sheet: "This sheet does not belong to your warehouse.",
			return_net_zero: "Everything back",
			return_over_returned: "More back than shipped",
			return_sheets: "Return order sheet",
			no_return_sheets: "No sheet yet — one is filed when the return order is printed.",
			article_not_found: "This article no longer exists.",
			article_group_not_found: "This article group no longer exists.",
			article_product_type_not_found: "This article product type no longer exists.",
			article_location_not_found: "This article is no longer assigned to that warehouse location.",
			vendor_article_not_found: "This vendor article no longer exists.",
			vendor_not_found: "This vendor no longer exists. Pick a different one.",
			order_template_not_found: "This order template no longer exists.",
			order_not_found: "This order no longer exists.",
			order_project_not_found: "The project for this order no longer exists. Pick a different one.",
			suborder_not_found: "This suborder no longer exists.",
			suborder_state_changed:
				"This suborder has moved on since you opened it. Reload to see its current state.",
			suborder_not_picking:
				"This suborder is not being picked at the moment, so no pick can be booked on it.",
			article_not_in_order: "This order does not contain that article.",
			tour_wave_not_found: "This tour wave no longer exists.",
			return_order_not_found: "This return order no longer exists.",
			return_order_closed:
				"This return order is already closed. Nothing further can be booked onto it.",
			load_carrier_not_found: "This load carrier no longer exists.",
			transfer_carrier_not_found: "This transfer carrier no longer exists.",
			warehouse_location_not_found: "This warehouse location no longer exists.",
			warehouse_zone_not_found: "This warehouse zone no longer exists.",
			follow_up_zone_not_found: "The chosen follow-up zone no longer exists. Pick a different one.",
		},
		terminals: {
			enter_pin_prompt: "Enter pin to check in or out",
			not_checked_in: "Not checked in",
			today: "Today",
			today_total: "Total today",
			week_total: "This week",
			now: "Now",
			terminal_worksite: "Terminal Worksite",
			terminal_worksite_description:
				"Attendances booked at this terminal are recorded on this worksite.",
			approve_terminal: "Approve Terminal",
			approve_terminal_description: "Scan the QR code shown on the terminal you want to approve.",
			approving_terminal: "Approving terminal...",
			terminal_approved_successfully: "Terminal approved successfully",
			approving_terminal_failed: "Approving terminal failed",
			pairing_request_not_found:
				"This terminal has no request waiting for approval. Restart the terminal and scan its QR code again.",
		},
	},
};
